function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from "react";
import Profiles from "../img/profile/little-girl.png";
/* create-project */
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import moment from "moment-timezone";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form, Formik, FieldArray, getIn } from "formik";
import * as Yup from "yup";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import { FilterContext, UserContext, SearchContext } from "../index";
import { MY_PROJECTS_QUERY,
// ADD_NEW_PROJECT_MUTATION,
EDIT_PROJECT_AND_DELETE_PROJECT_MUTATION, ORGANISATION_TEAMS_QUERY, PROJECT_USER_DETAILS_DATA_QUERY, MY_PROJECT_HEADER_QUERY, ADD_NEW_PROJECT_DETAILS_MUTATION, UPDATE_PROJECT_ESTIMATED_TIME_MUTATION, MY_PROJECT_SUMMARY_QUERY, ADD_PROJECT_WORKDAY_SETTINGS_MUTATION, MY_PROJECT_TASK_DEADLINE, MY_PROJECT_PROJECT_DEADLINE } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import Loader from "./../Loader/Loader";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { toast } from "react-toastify";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import ProgressBar from "react-bootstrap/ProgressBar";
/* edit-project */
import { MdAddCircleOutline, MdCheck } from "react-icons/md";
import "./CreateProject.css";
import "./MyProjects.css";
import "./PersonalTask.css";
import { PersonalTask } from "./PersonalTask.js";
import { PROJECT_LISTING_QUERY } from "./../SideMenu/query";
import InputGroup from "react-bootstrap/InputGroup";
import { VscLoading } from "react-icons/vsc";
import Profile from "../img/profile/little-girl.png";
import { arrayToStringOutput } from "./../SideMenu/Header";
import SearchBar from "../SearchBar";
import { MdAccessTime, MdAdd } from "react-icons/md";
import { WEB_ORGANISATION_SETTINGS_QUERY, WORK_DAY_SETTINGS_QUERY } from "../TimesheetSettings/query";
import { TASK_OVERVIEW_SUMMARY_DATA_QUERY } from "../TaskOverview/query";
import { GET_TASK_TRACKER_QUERY, TASK_USERS_QUERY } from "../ManualPages/query";
import { PROJECT_DETAILS_SUMMARY_QUERY, ADD_TASK_DETAILS_MUTATION, ADD_USER_TASK_DETAILS_MUTATION } from "../ProjectDetails/query";
import { FaRegFolderOpen } from "react-icons/fa";
import { FiCheckSquare, FiAlertTriangle, FiMoreHorizontal, FiUsers, FiCalendar } from "react-icons/fi";
import { IoMdCheckmarkCircleOutline, IoMdPersonAdd } from "react-icons/io";
import Badge from "react-bootstrap/Badge";
import Dropdown from "react-bootstrap/Dropdown";
import { HiOutlineDotsVertical } from "react-icons/hi";
import Select from "react-select";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { HiLockClosed } from "react-icons/hi";
import Accordion from "react-bootstrap/Accordion";
import DatePicker from "react-datepicker";
import Table from "react-bootstrap/Table";
var projectSchema = Yup.object().shape({
  projectName: Yup.string().trim().required("Required")
  // projectTime: Yup.number().positive().min(0, "only positive value"),
  // projectManagers: Yup.array().of(Yup.string()).min(1, "Required atleast 1 option").required("Required atleast 1 option"),
});
var taskPriority = [{
  label: "Low",
  value: "low"
}, {
  label: "Medium",
  value: "medium"
}, {
  label: "High",
  value: "high"
}];
function validateReportOf(value) {
  var error;
  if (!value) {
    error = "Required";
  } else if (value.length < 1) {
    error = "Required atleast 1 option";
  }
  return error;
}
var LIMIT = 15;
var TASK_EMP_LIMIT = 10;
var allOffsets = 0;
var currentlyWorkingoffsets = 0;
var overWorkOffsets = 0;
var todayWorkOffsets = 0;
var archivedOffsets = 0;
var deadlineOffsets = 0;
var MyProjects = function MyProjects(props) {
  var _user$organisations, _organisationDetails$, _myProjectsData$myPro5, _myProjectHeaderData$;
  var Link = props.linkComponent;
  var linkProps = props.linkProps;
  var history = props === null || props === void 0 ? void 0 : props.history;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    projectModalShow = _useState2[0],
    setShow = _useState2[1];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showDeleteModal = _React$useState2[0],
    setShowDeleteModal = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isAllLoaded = _React$useState4[0],
    setIsAllLoaded = _React$useState4[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoadingMore = _useState4[0],
    setIsLoadingMore = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoadMoreButton = _useState6[0],
    setIsLoadMoreButton = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    addedProjectId = _useState8[0],
    setAddedProjectId = _useState8[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showUserMap = _React$useState6[0],
    setShowUserMap = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isEstimationHover = _React$useState8[0],
    setEstimationHover = _React$useState8[1];
  var _React$useState9 = React.useState(""),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    projectEstimationTime = _React$useState10[0],
    addProjectEstimationTime = _React$useState10[1];
  var _useState9 = useState("all"),
    _useState10 = _slicedToArray(_useState9, 2),
    filterId = _useState10[0],
    setFilterId = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isCurrentlyWorkingLoaded = _useState12[0],
    setIsCurrentlyWorkingLoaded = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isOverWorkLoaded = _useState14[0],
    setIsOverWorkLoaded = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isTodayWorkLoaded = _useState16[0],
    setIsTodayWorkLoaded = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isArchivedLoaded = _useState18[0],
    setIsArchivedLoaded = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isDeadlineLoaded = _useState20[0],
    setIsDeadlineLoaded = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isGettingData = _useState22[0],
    setIsGettingData = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    refetchStatus = _useState24[0],
    setRetchStatus = _useState24[1];
  var _useState25 = useState({
      label: "All Projects",
      value: "all"
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    selectFilter = _useState26[0],
    setSelectFilter = _useState26[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    if (role === "Member" && !organisationSettings.projectManagementFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);

  //const { search: projectSearch } = React.useContext(SearchContext);

  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var organisationDetails = (user === null || user === void 0 ? void 0 : (_user$organisations = user.organisations) === null || _user$organisations === void 0 ? void 0 : _user$organisations.find(function (organisation) {
    return organisation.id === organisationId;
  })) || {};
  var teamDatas = (organisationDetails === null || organisationDetails === void 0 ? void 0 : (_organisationDetails$ = organisationDetails.teams) === null || _organisationDetails$ === void 0 ? void 0 : _organisationDetails$.find(function (team) {
    return team.id === teamId;
  })) || {};
  var _React$useContext3 = React.useContext(SearchContext),
    projectSearch = _React$useContext3.search,
    setSearch = _React$useContext3.setSearch;
  var _useQuery = useQuery(MY_PROJECT_SUMMARY_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        role: role
      },
      skip: !organisationId
    }),
    myProjectSummaryData = _useQuery.data,
    myProjectSummaryError = _useQuery.error,
    myProjectSummaryLoading = _useQuery.loading,
    mySummaryRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(MY_PROJECT_HEADER_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
        role: role
        //search: projectSearch,
      },
      skip: !organisationId
    }),
    myProjectHeaderData = _useQuery2.data,
    myProjectHeaderError = _useQuery2.error,
    myProjectHeaderLoading = _useQuery2.loading,
    refetch = _useQuery2.refetch;
  var _useQuery3 = useQuery(MY_PROJECTS_QUERY, {
      variables: {
        organisationId: organisationId,
        url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        limit: LIMIT,
        offset: 0,
        filter: filterId,
        role: role,
        search: projectSearch
      },
      skip: !organisationId || !teamId
    }),
    myProjectsData = _useQuery3.data,
    myProjectsError = _useQuery3.error,
    myProjectsLoading = _useQuery3.loading,
    myProjectsRefetch = _useQuery3.refetch,
    fetchMore = _useQuery3.fetchMore;
  var _useQuery4 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    teamsData = _useQuery4.data,
    teamsError = _useQuery4.error,
    teamsLoading = _useQuery4.loading,
    teamsRefetch = _useQuery4.refetch;
  React.useEffect(function () {
    if (myProjectsData && !myProjectsLoading) {
      setIsGettingData(true);
      setRetchStatus(false);
    }
  }, [myProjectsData]);
  React.useEffect(function () {
    var _myProjectsData$myPro, _myProjectsData$myPro2, _myProjectsData$myPro3, _myProjectsData$myPro4;
    if ((myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro = myProjectsData.myProjects) === null || _myProjectsData$myPro === void 0 ? void 0 : (_myProjectsData$myPro2 = _myProjectsData$myPro.projectsData) === null || _myProjectsData$myPro2 === void 0 ? void 0 : _myProjectsData$myPro2.length) !== 0 && (myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro3 = myProjectsData.myProjects) === null || _myProjectsData$myPro3 === void 0 ? void 0 : (_myProjectsData$myPro4 = _myProjectsData$myPro3.projectsData) === null || _myProjectsData$myPro4 === void 0 ? void 0 : _myProjectsData$myPro4.length) < LIMIT) {
      if (filterId == "all") {
        setIsAllLoaded(true);
      } else if (filterId == "start") {
        setIsCurrentlyWorkingLoaded(true);
      } else if (filterId == "over") {
        setIsOverWorkLoaded(true);
      } else if (filterId == "todayWork") {
        setIsTodayWorkLoaded(true);
      } else if (filterId == "archived") {
        setIsArchivedLoaded(true);
      } else if (filterId == "deadline") {
        setIsDeadlineLoaded(true);
      }
    }
  }, [myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro5 = myProjectsData.myProjects) === null || _myProjectsData$myPro5 === void 0 ? void 0 : _myProjectsData$myPro5.projectsData, filterId, props.location.key]);
  React.useEffect(function () {
    myProjectsRefetch === null || myProjectsRefetch === void 0 ? void 0 : myProjectsRefetch();
  }, [filterId]);
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
    mySummaryRefetch === null || mySummaryRefetch === void 0 ? void 0 : mySummaryRefetch();
    myProjectsRefetch === null || myProjectsRefetch === void 0 ? void 0 : myProjectsRefetch();
    teamsRefetch === null || teamsRefetch === void 0 ? void 0 : teamsRefetch();
  }, [props.location.key]);

  // Reset load more flags when search is cleared
  React.useEffect(function () {
    if (projectSearch === "") {
      if (filterId === "all") setIsAllLoaded(false);else if (filterId === "start") setIsCurrentlyWorkingLoaded(false);else if (filterId === "over") setIsOverWorkLoaded(false);else if (filterId === "todayWork") setIsTodayWorkLoaded(false);else if (filterId === "archived") setIsArchivedLoaded(false);else if (filterId === "deadline") setIsDeadlineLoaded(false);
    }
  }, [projectSearch, filterId]);
  if (myProjectHeaderLoading || myProjectSummaryLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (myProjectHeaderError || myProjectSummaryError) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }
  if (!myProjectHeaderData) {
    return /*#__PURE__*/React.createElement("div", null, "No data");
  }
  var projectStatusCountData = myProjectHeaderData === null || myProjectHeaderData === void 0 ? void 0 : (_myProjectHeaderData$ = myProjectHeaderData.myProjectHeader) === null || _myProjectHeaderData$ === void 0 ? void 0 : _myProjectHeaderData$.projectStatusCount;
  var teamDetails = !teamsLoading && !teamsError ? teamsData === null || teamsData === void 0 ? void 0 : teamsData.organisationTeams : null;
  var projectWithSearch = function projectWithSearch(projectsData) {
    if (!projectSearch) {
      return projectsData;
    }
    return projectsData.filter(function (filterProjectsData) {
      return ((filterProjectsData === null || filterProjectsData === void 0 ? void 0 : filterProjectsData.displayName) || "").toLowerCase().includes(projectSearch.toLowerCase());
    });
  };
  var getOffsetValue = function getOffsetValue() {
    if (filterId == "all" && isGettingData) {
      setIsAllLoaded(true);
    } else if (filterId == "start" && isGettingData) {
      setIsCurrentlyWorkingLoaded(true);
    } else if (filterId == "over" && isGettingData) {
      setIsOverWorkLoaded(true);
    } else if (filterId == "todayWork" && isGettingData) {
      setIsTodayWorkLoaded(true);
    } else if (filterId == "archived" && isGettingData) {
      setIsArchivedLoaded(true);
    } else if (filterId == "deadline" && isGettingData) {
      setIsDeadlineLoaded(true);
    }
  };
  var getOffsetValueFalse = function getOffsetValueFalse(value) {
    if (value == "all" && !isAllLoaded) {
      setIsAllLoaded(false);
    } else if (value == "start") {
      setIsCurrentlyWorkingLoaded(false);
    } else if (value == "over" && !isOverWorkLoaded) {
      setIsOverWorkLoaded(false);
    } else if (value == "todayWork" && !isTodayWorkLoaded) {
      setIsTodayWorkLoaded(false);
    } else if (value == "archived" && !isArchivedLoaded) {
      setIsArchivedLoaded(false);
    } else if (value == "deadline" && !isDeadlineLoaded) {
      setIsDeadlineLoaded(false);
    }
  };
  var handleLoadMore = function handleLoadMore() {
    if (myProjectsLoading) return;
    setIsLoadingMore(true);
    var offsets = 0;
    if (filterId == "all") {
      allOffsets = allOffsets + 1;
      offsets = allOffsets;
    } else if (filterId == "start") {
      currentlyWorkingoffsets = currentlyWorkingoffsets + 1;
      offsets = currentlyWorkingoffsets;
    } else if (filterId == "over") {
      overWorkOffsets = overWorkOffsets + 1;
      offsets = overWorkOffsets;
    } else if (filterId == "todayWork") {
      todayWorkOffsets = todayWorkOffsets + 1;
      offsets = todayWorkOffsets;
    } else if (filterId == "archived") {
      archivedOffsets = archivedOffsets + 1;
      offsets = archivedOffsets;
    } else if (filterId == "deadline") {
      deadlineOffsets = deadlineOffsets + 1;
      offsets = deadlineOffsets;
    }
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$myPr, _fetchMoreResult$myPr2, _fetchMoreResult$myPr3, _fetchMoreResult$myPr4, _fetchMoreResult$myPr5, _prev$myProjects, _fetchMoreResult$myPr6;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$myPr = fetchMoreResult.myProjects) === null || _fetchMoreResult$myPr === void 0 ? void 0 : (_fetchMoreResult$myPr2 = _fetchMoreResult$myPr.projectsData) === null || _fetchMoreResult$myPr2 === void 0 ? void 0 : _fetchMoreResult$myPr2.length) === 0 && ((_fetchMoreResult$myPr3 = fetchMoreResult.myProjects) === null || _fetchMoreResult$myPr3 === void 0 ? void 0 : _fetchMoreResult$myPr3.projectsData.length) < LIMIT || (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$myPr4 = fetchMoreResult.myProjects) === null || _fetchMoreResult$myPr4 === void 0 ? void 0 : (_fetchMoreResult$myPr5 = _fetchMoreResult$myPr4.projectsData) === null || _fetchMoreResult$myPr5 === void 0 ? void 0 : _fetchMoreResult$myPr5.length) !== 0 && fetchMoreResult.myProjects.projectsData.length < LIMIT) {
          getOffsetValue();
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          myProjects: _objectSpread(_objectSpread({}, prev.myProjects), {}, {
            projectsData: [].concat(_toConsumableArray((_prev$myProjects = prev.myProjects) === null || _prev$myProjects === void 0 ? void 0 : _prev$myProjects.projectsData), _toConsumableArray((_fetchMoreResult$myPr6 = fetchMoreResult.myProjects) === null || _fetchMoreResult$myPr6 === void 0 ? void 0 : _fetchMoreResult$myPr6.projectsData))
          })
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root"
  }, /*#__PURE__*/React.createElement(SummaryCard, {
    myProjectSummaryData: myProjectSummaryData,
    projectStatusCountData: projectStatusCountData,
    role: role
  }), /*#__PURE__*/React.createElement(ContentCard, {
    projectSearch: projectSearch,
    setSearch: setSearch,
    myProjectsLoading: myProjectsLoading,
    myProjectsError: myProjectsError,
    myProjectsData: myProjectsData,
    projectWithSearch: projectWithSearch,
    filterId: filterId,
    isAllLoaded: isAllLoaded,
    isCurrentlyWorkingLoaded: isCurrentlyWorkingLoaded,
    isOverWorkLoaded: isOverWorkLoaded,
    isArchivedLoaded: isArchivedLoaded,
    isDeadlineLoaded: isDeadlineLoaded,
    isTodayWorkLoaded: isTodayWorkLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    handleLoadMore: handleLoadMore,
    Link: Link,
    linkProps: linkProps,
    history: history,
    projectStatusCountData: projectStatusCountData,
    organisationBilling: organisationBilling,
    role: role,
    setFilterId: setFilterId,
    setIsGettingData: setIsGettingData,
    getOffsetValueFalse: getOffsetValueFalse,
    setSelectFilter: setSelectFilter,
    selectFilter: selectFilter,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    teamDetails: teamDetails,
    organisationId: organisationId,
    teamId: teamId
  }));
};
var SummaryCard = function SummaryCard(props) {
  var _projectStatusCountDa, _myProjectSummaryData, _myProjectSummaryData2, _myProjectSummaryData3, _myProjectSummaryData4, _myProjectSummaryData5, _myProjectSummaryData6, _myProjectSummaryData7, _myProjectSummaryData8, _projectStatusCountDa2, _myProjectSummaryData9, _myProjectSummaryData10, _myProjectSummaryData11, _myProjectSummaryData12, _myProjectSummaryData13, _myProjectSummaryData14;
  var projectStatusCountData = props.projectStatusCountData,
    myProjectSummaryData = props.myProjectSummaryData,
    role = props.role;
  return /*#__PURE__*/React.createElement(React.Fragment, null, role == "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section my-projects-root-summary-section-total-project"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Total Projects"), /*#__PURE__*/React.createElement(FaRegFolderOpen, {
    className: "my-projects-root-summary-section-header-text-icon"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, (_projectStatusCountDa = projectStatusCountData[0]) === null || _projectStatusCountDa === void 0 ? void 0 : _projectStatusCountDa.count)), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section my-projects-root-summary-section-assigned-task"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Assigned Tasks"), /*#__PURE__*/React.createElement(FiCheckSquare, {
    className: "my-projects-root-summary-section-header-text-icon-assigned"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData2 = _myProjectSummaryData.projectSummary) === null || _myProjectSummaryData2 === void 0 ? void 0 : _myProjectSummaryData2.taskAssignedToMe)), /*#__PURE__*/React.createElement("div", {
    className: classNames("my-projects-root-summary-section", {
      "my-projects-root-summary-section-assigned-task-due": role !== "Admin" && role !== "Head"
    }, {
      "my-projects-root-summary-section-assigned-task": role == "Admin" || role == "Head"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Tasks Due"), role === "Admin" || role == "Head" ? /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "my-projects-root-summary-section-header-text-icon"
  }) : /*#__PURE__*/React.createElement(FiAlertTriangle, {
    className: "my-projects-root-summary-section-header-text-icon-due"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData3 = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData3 === void 0 ? void 0 : (_myProjectSummaryData4 = _myProjectSummaryData3.projectSummary) === null || _myProjectSummaryData4 === void 0 ? void 0 : _myProjectSummaryData4.onDueTaskCount)), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section my-projects-root-summary-section-completed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Task Completed"), role === "Admin" || role == "Head" ? /*#__PURE__*/React.createElement(FiUsers, {
    className: "my-projects-root-summary-section-header-text-icon-completed"
  }) : /*#__PURE__*/React.createElement(IoMdCheckmarkCircleOutline, {
    className: "my-projects-root-summary-section-header-text-icon-completed"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData5 = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData5 === void 0 ? void 0 : (_myProjectSummaryData6 = _myProjectSummaryData5.projectSummary) === null || _myProjectSummaryData6 === void 0 ? void 0 : _myProjectSummaryData6.completedTaskCount))) : /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section my-projects-root-summary-section-total-project"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Today Worked Tasks & Projects"), /*#__PURE__*/React.createElement(FaRegFolderOpen, {
    className: "my-projects-root-summary-section-header-text-icon"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData7 = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData7 === void 0 ? void 0 : (_myProjectSummaryData8 = _myProjectSummaryData7.projectSummary) === null || _myProjectSummaryData8 === void 0 ? void 0 : _myProjectSummaryData8.todayWorkedCount, " ", /*#__PURE__*/React.createElement("span", {
    className: "my-projects-root-summary-section-count-span"
  }, "tasks in"), " ", (_projectStatusCountDa2 = projectStatusCountData[1]) === null || _projectStatusCountDa2 === void 0 ? void 0 : _projectStatusCountDa2.count, " ", /*#__PURE__*/React.createElement("span", {
    className: "my-projects-root-summary-section-count-span"
  }, "projects"))), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section my-projects-root-summary-section-assigned-task"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Today Completed Time On Tasks"), /*#__PURE__*/React.createElement(FiCheckSquare, {
    className: "my-projects-root-summary-section-header-text-icon-assigned"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData9 = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData9 === void 0 ? void 0 : (_myProjectSummaryData10 = _myProjectSummaryData9.projectSummary) === null || _myProjectSummaryData10 === void 0 ? void 0 : _myProjectSummaryData10.todayWorkedHours)), /*#__PURE__*/React.createElement("div", {
    className: classNames("my-projects-root-summary-section", {
      "my-projects-root-summary-section-assigned-task-due": role !== "Admin" && role !== "Head"
    }, {
      "my-projects-root-summary-section-assigned-task": role == "Admin" || role == "Head"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Today Ongoing Task Time"), role === "Admin" || role == "Head" ? /*#__PURE__*/React.createElement(MdAccessTime, {
    className: "my-projects-root-summary-section-header-text-icon"
  }) : /*#__PURE__*/React.createElement(FiAlertTriangle, {
    className: "my-projects-root-summary-section-header-text-icon-due"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData11 = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData11 === void 0 ? void 0 : (_myProjectSummaryData12 = _myProjectSummaryData11.projectSummary) === null || _myProjectSummaryData12 === void 0 ? void 0 : _myProjectSummaryData12.todayOngoingTimeHour)), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section my-projects-root-summary-section-completed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-summary-section-header-text"
  }, "Today Worked Members"), role === "Admin" || role == "Head" ? /*#__PURE__*/React.createElement(FiUsers, {
    className: "my-projects-root-summary-section-header-text-icon-completed"
  }) : /*#__PURE__*/React.createElement(IoMdCheckmarkCircleOutline, {
    className: "my-projects-root-summary-section-header-text-icon-completed"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "my-projects-root-summary-section-count mb-0 mt-1 font-weight-bold text-dark"
  }, myProjectSummaryData === null || myProjectSummaryData === void 0 ? void 0 : (_myProjectSummaryData13 = myProjectSummaryData.myProjectSummary) === null || _myProjectSummaryData13 === void 0 ? void 0 : (_myProjectSummaryData14 = _myProjectSummaryData13.projectSummary) === null || _myProjectSummaryData14 === void 0 ? void 0 : _myProjectSummaryData14.todayWorkedMembers))));
};
var ContentCard = function ContentCard(props) {
  var _myProjectsData$myPro6, _myProjectsData$myPro7, _projectWithSearch, _myProjectsData$myPro8, _myProjectsData$myPro9, _projectWithSearch2, _myProjectsData$myPro10;
  var projectSearch = props.projectSearch,
    setSearch = props.setSearch,
    myProjectsLoading = props.myProjectsLoading,
    myProjectsError = props.myProjectsError,
    myProjectsData = props.myProjectsData,
    projectWithSearch = props.projectWithSearch,
    filterId = props.filterId,
    isAllLoaded = props.isAllLoaded,
    isCurrentlyWorkingLoaded = props.isCurrentlyWorkingLoaded,
    isOverWorkLoaded = props.isOverWorkLoaded,
    isArchivedLoaded = props.isArchivedLoaded,
    isDeadlineLoaded = props.isDeadlineLoaded,
    isTodayWorkLoaded = props.isTodayWorkLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    Link = props.Link,
    linkProps = props.linkProps,
    history = props.history,
    projectStatusCountData = props.projectStatusCountData,
    organisationBilling = props.organisationBilling,
    role = props.role,
    setFilterId = props.setFilterId,
    setIsGettingData = props.setIsGettingData,
    getOffsetValueFalse = props.getOffsetValueFalse,
    setSelectFilter = props.setSelectFilter,
    selectFilter = props.selectFilter,
    timeZone = props.timeZone,
    teamDetails = props.teamDetails,
    organisationId = props.organisationId,
    teamId = props.teamId;
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    projectModalShow = _useState28[0],
    setShow = _useState28[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    showUserMap = _React$useState12[0],
    setShowUserMap = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    taskDeadlineModalShow = _React$useState14[0],
    setTaskDeadlineModalShow = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    projectDeadlineModalShow = _React$useState16[0],
    setProjectDeadlineModalShow = _React$useState16[1];
  var _React$useState17 = React.useState(null),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    addTaskShow = _React$useState18[0],
    setAddTaskShow = _React$useState18[1];
  var _React$useState19 = React.useState("projects"),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    tableView = _React$useState20[0],
    setTableView = _React$useState20[1];

  //const selectedFilter = projectStatusCountData.find(item => item.value === filterId);
  var selectedFilter = (projectStatusCountData || []).find(function (item) {
    return item.value === filterId;
  });

  // Check for plan restriction
  var isArchivedOnFreePlan = (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) === "free" && (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.value) === "archived";
  var dateOptionListAdmin = [{
    label: "All Projects",
    value: "all"
  }, {
    label: "Today Worked",
    value: "todayWork"
  }, {
    label: "Estimation Hours Crossed",
    value: "over"
  }, {
    label: "Archived Project",
    value: "archived"
  }, {
    label: "Deadline Crossed Project",
    value: "deadline"
  }];
  var dateOptionList = [{
    label: "All Projects",
    value: "all"
  }, {
    label: "Today Worked",
    value: "todayWork"
  }];
  var dateOptionListAdminforFree = [{
    label: "All Projects",
    value: "all"
  }, {
    label: "Today Worked",
    value: "todayWork"
  }, {
    label: "Estimation Hours Crossed",
    value: "over"
  }, {
    label: "Deadline Crossed Project",
    value: "deadline"
  }];
  var handleClose = function handleClose() {
    setShow(null);
    setShowUserMap(false);
  };
  var handleShow = function handleShow(modalType, teamDetails, projectName, projectId, selectedTeam, estimatedTime, projectSelectedHeadList) {
    var temp = {
      modalType: modalType,
      teamDetails: teamDetails,
      organisationId: organisationId,
      projectName: projectName,
      projectId: projectId,
      selectedTeam: selectedTeam,
      teamId: teamId,
      estimatedTime: estimatedTime,
      projectSelectedHeadList: projectSelectedHeadList
    };
    setShow(temp);
  };
  var handleCloseTaskDeadlineDetails = function handleCloseTaskDeadlineDetails() {
    setTaskDeadlineModalShow(null);
  };
  var handleShowTaskDetails = function handleShowTaskDetails(list) {
    setTaskDeadlineModalShow(list);
  };
  var handleCloseProjectDeadlineDetails = function handleCloseProjectDeadlineDetails() {
    setProjectDeadlineModalShow(null);
  };
  var handleShowProjectDetails = function handleShowProjectDetails(list) {
    setProjectDeadlineModalShow(list);
  };
  var handleTaskClose = function handleTaskClose() {
    setAddTaskShow(null);
  };
  var handleTaskShow = function handleTaskShow(projectId) {
    setAddTaskShow(projectId);
  };
  var handleWholeTabSelect = function handleWholeTabSelect(key) {
    setTableView(key);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-side-bar-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-div-header-text"
  }, "Quick Actions"), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-side-bar-whole-buttont-div"
  }, role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "add-projects-button"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, " ", projectStatusCountData[0].count >= 2 && organisationBilling.planName == "free" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to create projects")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project"
  }, /*#__PURE__*/React.createElement(MdAdd, {
    className: "myproject-start-new-project-svg"
  }), " Start New Project")) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleShow("AddProject", teamDetails);
    },
    disabled: organisationBilling.planName == "free" && !myProjectsData
  }, /*#__PURE__*/React.createElement(MdAdd, {
    className: "myproject-start-new-project-svg"
  }), " Start New Project"))) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Only the admin can add projects.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project"
  }, /*#__PURE__*/React.createElement(MdAdd, {
    className: "myproject-start-new-project-svg"
  }), " Start New Project")), /*#__PURE__*/React.createElement("div", {
    className: "add-projects-button"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-project-name"
    }, "Coming Soon")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project"
  }, /*#__PURE__*/React.createElement(FaRegFolderOpen, {
    className: "myproject-start-new-project-svg"
  }), " Create New Task"))), /*#__PURE__*/React.createElement("div", {
    className: "add-projects-button"
  }, organisationBilling.planName == "free" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade pro or premium plan to see project deadline")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "myproject-start-new-project-svg"
  }), " Project Deadlines")) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleShowProjectDetails("projectDeadline");
    },
    disabled: organisationBilling.planName == "free" && !myProjectsData
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "myproject-start-new-project-svg"
  }), " Project Deadlines")), /*#__PURE__*/React.createElement("div", {
    className: "add-projects-button"
  }, organisationBilling.planName == "free" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade pro or premium plan to see task deadline")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project"
  }, /*#__PURE__*/React.createElement(FiAlertTriangle, {
    className: "myproject-start-new-project-svg"
  }), " Task Deadline")) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "myproject-start-new-project",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleShowTaskDetails("taskDeadline");
    },
    disabled: organisationBilling.planName == "free" && !myProjectsData
  }, /*#__PURE__*/React.createElement(FiAlertTriangle, {
    className: "myproject-start-new-project-svg"
  }), " Task Deadline"))))), /*#__PURE__*/React.createElement(Tabs, {
    className: "project-tab-div-table-view-whole",
    defaultActiveKey: "projects",
    onSelect: function onSelect(e) {
      handleWholeTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "projects",
    title: /*#__PURE__*/React.createElement("span", null, "Projects")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshots-card-searchbar-div"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: projectSearch,
    onChange: setSearch,
    placeholder: "Search projects...",
    className: "screenshots-card-searchbar"
  })), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-user-activity-project-filter"
  }, /*#__PURE__*/React.createElement(Select, {
    value: selectFilter,
    onChange: function onChange(e) {
      setSelectFilter(e);
      setFilterId(e.value);
      getOffsetValueFalse(e.value);
      setIsGettingData(false);
      setSearch("");
    },
    options: role == "Admin" ? (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) === "free" ? dateOptionListAdminforFree : dateOptionListAdmin : dateOptionList,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  }))), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-div-header-text-whole"
  }, selectedFilter && !isArchivedOnFreePlan && /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-div-header-text"
  }, "Projects ", !projectSearch.length ? "(".concat(selectedFilter.count, ")") : ""), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-div-header-text-whole-wrapper"
  }, role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "add-projects-button"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, " ", projectStatusCountData[0].count >= 2 && organisationBilling.planName == "free" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to create projects")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-details-task-card-body-filter-section-buttions-add-button-root-new"
  }, "+ Create Project")) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-details-task-card-body-filter-section-buttions-add-button-root-new",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleShow("AddProject", teamDetails);
    }
  }, "+ Create Project"))) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Only the admin can add projects.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-details-task-card-body-filter-section-buttions-add-button-root-new"
  }, "+ Create Project")))), myProjectsLoading ? /*#__PURE__*/React.createElement(Loader, null) : myProjectsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-root-content-section-whole-filter-content-list-div-content-div"
  }, (myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro6 = myProjectsData.myProjects) === null || _myProjectsData$myPro6 === void 0 ? void 0 : (_myProjectsData$myPro7 = _myProjectsData$myPro6.projectsData) === null || _myProjectsData$myPro7 === void 0 ? void 0 : _myProjectsData$myPro7.length) === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No Projects found"), /*#__PURE__*/React.createElement("div", null)) : !((_projectWithSearch = projectWithSearch(myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro8 = myProjectsData.myProjects) === null || _myProjectsData$myPro8 === void 0 ? void 0 : _myProjectsData$myPro8.projectsData)) !== null && _projectWithSearch !== void 0 && _projectWithSearch.length) ? /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No projects found for \"".concat(projectSearch, "\"\n                                      ")) : projectWithSearch(myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro9 = myProjectsData.myProjects) === null || _myProjectsData$myPro9 === void 0 ? void 0 : _myProjectsData$myPro9.projectsData).map(function (projectCardValue, index) {
    var assignedTo = "";
    var assignedToAll = "";
    var userCount = 0;
    projectCardValue === null || projectCardValue === void 0 ? void 0 : projectCardValue.recentProjectUser.map(function (recent) {
      assignedTo += userCount == 0 ? recent.user.displayName : "";
      assignedToAll += userCount == 0 ? recent.user.displayName : ", " + recent.user.displayName;
      userCount++;
    });
    if (userCount > 1) {
      assignedTo += " & " + (userCount - 1) + " Others";
      //assignedTo = assignedTo.length > 16 ? userCount + " Members" : assignedTo;
    }
    var trimDisplayName = projectCardValue.displayName.trim();
    return /*#__PURE__*/React.createElement("div", {
      className: "position-relative project-card-div-wrapper ".concat(projectCardValue.recentProjectDateText == " worked today" ? "project-card-div-wrapper-today" : null),
      key: projectCardValue.projectId
    }, /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/project-details/".concat(projectCardValue.projectId)), {
      className: classNames("project-card d-block  white", projectCardValue === null || projectCardValue === void 0 ? void 0 : projectCardValue.currentWorkStatus)
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames("project-whole-color-border-div", {
        "project-whole-color-border-div-over": (projectCardValue === null || projectCardValue === void 0 ? void 0 : projectCardValue.taskStatus) == "overdue"
      }, {
        "project-whole-color-border-div-active": projectCardValue.taskStatus == "active"
      }, {
        "project-whole-color-border-div-completed": projectCardValue.taskStatus == "completed"
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center project-card-project-name-div"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-project-name"
      }, projectCardValue.displayName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-card-projectname "
    }, projectCardValue.displayName)))), /*#__PURE__*/React.createElement("div", {
      className: "project-members-div-whole"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-whole"
      }, projectCardValue.projectUserWithAdminUserId.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, projectCardValue.projectUserWithAdminUserId.slice(0, 25).map(function (data, key) {
        return /*#__PURE__*/React.createElement("div", {
          className: "count-tooltip-header"
        }, /*#__PURE__*/React.createElement("img", {
          alt: "Workfolio",
          src: data.profileUrl ? data.profileUrl : Profile,
          className: "count-tooltip-user-content-img",
          width: "15",
          height: "15"
        }), /*#__PURE__*/React.createElement("p", {
          className: "count-tooltip-user-content"
        }, data.displayName));
      }), projectCardValue.projectUserWithAdminUserId > 25 ? /*#__PURE__*/React.createElement("p", {
        className: "count-tooltip-user-content"
      }, "+", projectCardValue.projectUserWithAdminUserId - 25, " others") : null) : /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-header"
      }, " No members")))
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-whole-div-person"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-whole-div-person-text"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "project-team-card-footer-online-whole-div-person-text-svg"
    }), /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-whole-div-person-text-svg-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-whole-div-person-text-svg-text-count"
    }, projectCardValue.projectUserWithAdminUserId.length), " Members")))), projectCardValue.projectDeadline ? /*#__PURE__*/React.createElement("div", {
      className: classNames("project-card-projectname-deadline-textual", {
        "project-whole-color-border-div-over-due-span": (projectCardValue === null || projectCardValue === void 0 ? void 0 : projectCardValue.taskStatus) == "overdue"
      })
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: classNames("project-card-total-worked-time-icon-due", {
        "project-whole-color-border-div-over-due-span": (projectCardValue === null || projectCardValue === void 0 ? void 0 : projectCardValue.taskStatus) == "overdue"
      })
    }), "Due ", moment.unix(projectCardValue.projectDeadline / 1000).format("DD MMM, YYYY")) : /*#__PURE__*/React.createElement("div", {
      className: "project-card-projectname-deadline-textual-no-text"
    }, "No due date")), /*#__PURE__*/React.createElement("div", {
      className: "project-card-footer-chart",
      onClick: function onClick(e) {
        e.stopPropagation();
        history.push("/project-details/".concat(projectCardValue.projectId));
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-card-footer-chart-time"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-card-total-worked-time"
    }, /*#__PURE__*/React.createElement(MdAccessTime, {
      className: "project-card-total-worked-time-icon-clock"
    }), /*#__PURE__*/React.createElement("div", null, projectCardValue.projectTotalWorkedTime)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
      pill: true,
      variant: "success"
      //className="project-time-entries-root-body-listing-content-active-status"
      ,
      className: classNames({
        "project-time-entries-root-body-listing-content-active-status": projectCardValue.taskStatus == "active"
      }, {
        "project-time-entries-root-body-listing-content-completed-status": projectCardValue.taskStatus == "completed"
      }, {
        "project-time-entries-root-body-listing-content-overdue-status": projectCardValue.taskStatus == "overdue"
      })
    }, projectCardValue.taskStatus))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-whole-div-name-progress"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-whole-div-name-progress-span-text"
    }, "Task Distribution"), /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-whole-div-name-progress-span-count"
    }, projectCardValue.totalTaskCount, " total task")), /*#__PURE__*/React.createElement(ProgressBar, {
      className: "project-team-card-footer-online"
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      className: "project-team-card-footer-online-green",
      now: projectCardValue.avgCompletedTaskProgressPercentage,
      key: 1
    }), /*#__PURE__*/React.createElement(ProgressBar, {
      className: "project-team-card-footer-online-yellow",
      now: projectCardValue.avgInProgressTaskProgressPercentage,
      key: 2
    }), /*#__PURE__*/React.createElement(ProgressBar, {
      className: "project-team-card-footer-online-blue",
      now: projectCardValue.avgToDoTaskProgressPercentage,
      key: 3
    }), /*#__PURE__*/React.createElement(ProgressBar, {
      className: "project-team-card-footer-online-red",
      now: projectCardValue.avgHoldTaskProgressPercentage,
      key: 4
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div-completd"
    }), /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-span-whole-count-div-span"
    }, "Completed (", projectCardValue.completedTaskCount, ")")), /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div-inprogress"
    }), /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-span-whole-count-div-span"
    }, "In Progress (", projectCardValue.inProgressCount, ")")), /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div-todo"
    }), /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-span-whole-count-div-span"
    }, "To Do (", projectCardValue.upcomingTaskCount, ")")), /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-team-card-footer-online-span-whole-count-div-hold"
    }), /*#__PURE__*/React.createElement("span", {
      className: "project-team-card-footer-online-span-whole-count-div-span"
    }, "On Hold (", projectCardValue.holdTaskCount, ")"))))))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "project-card-screenshot-load-more-button"
  }, filterId == "all" && !isAllLoaded || filterId == "start" && !isCurrentlyWorkingLoaded || filterId == "over" && !isOverWorkLoaded || filterId == "archived" && !isArchivedLoaded || filterId == "deadline" && !isDeadlineLoaded || filterId == "todayWork" && !isTodayWorkLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "project-card-screenshot-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : !projectSearch && (_projectWithSearch2 = projectWithSearch(myProjectsData === null || myProjectsData === void 0 ? void 0 : (_myProjectsData$myPro10 = myProjectsData.myProjects) === null || _myProjectsData$myPro10 === void 0 ? void 0 : _myProjectsData$myPro10.projectsData)) !== null && _projectWithSearch2 !== void 0 && _projectWithSearch2.length ? /*#__PURE__*/React.createElement("p", {
    className: "project-card-screenshot-load-more-button project-management-miled-color"
  }, "You have seen all the projects") : null)))))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "personal-tasks",
    title: /*#__PURE__*/React.createElement("span", null, "Personal Tasks")
  }, /*#__PURE__*/React.createElement(PersonalTask, {
    organisationId: organisationId,
    tableView: tableView
  }))), /*#__PURE__*/React.createElement(ProjectModal, {
    projectModalShow: projectModalShow,
    handleClose: handleClose,
    timeZone: timeZone,
    role: role,
    history: history,
    showUserMap: showUserMap,
    setShowUserMap: setShowUserMap
  }), /*#__PURE__*/React.createElement(TaskDeadlineModal, {
    taskDeadlineModalShow: taskDeadlineModalShow,
    setTaskDeadlineModalShow: setTaskDeadlineModalShow
    // handleShowTaskDetails={handleShowTaskDetails}
    ,
    handleCloseTaskDeadlineDetails: handleCloseTaskDeadlineDetails,
    timeZone: timeZone,
    organisationId: organisationId,
    role: role
  }), /*#__PURE__*/React.createElement(ProjectDeadlineModal, {
    projectDeadlineModalShow: projectDeadlineModalShow,
    setProjectDeadlineModalShow: setProjectDeadlineModalShow
    // handleShowTaskDetails={handleShowTaskDetails}
    ,
    handleCloseProjectDeadlineDetails: handleCloseProjectDeadlineDetails,
    timeZone: timeZone,
    organisationId: organisationId,
    role: role
  }));
};
var EditMenuIcon = function EditMenuIcon(props) {
  _objectDestructuringEmpty(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "manage-teams-edit-menus"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(FiMoreHorizontal, {
    className: "manage-teams-edit-menus-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, null, "Edit"), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon"
    //onClick={() => handleDeleteShow(teamName, teamId, totalUsers, teamDeleteStatus, teamDeleteUser)}
  }, "Delete"), /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, null, "View"))));
};
var ProjectModal = function ProjectModal(props) {
  var _tasksOptionsData$get;
  var projectModalShow = props.projectModalShow,
    handleClose = props.handleClose,
    timeZone = props.timeZone,
    role = props.role,
    history = props.history,
    showUserMap = props.showUserMap,
    setShowUserMap = props.setShowUserMap;
  if (projectModalShow === null) {
    return null;
  }
  var modalType = projectModalShow.modalType,
    organisationId = projectModalShow.organisationId,
    projectName = projectModalShow.projectName,
    projectId = projectModalShow.projectId,
    selectedTeam = projectModalShow.selectedTeam,
    teamId = projectModalShow.teamId,
    startDate = projectModalShow.startDate,
    endDate = projectModalShow.endDate,
    estimatedTime = projectModalShow.estimatedTime,
    projectSelectedHeadList = projectModalShow.projectSelectedHeadList;
  var _useQuery5 = useQuery(PROJECT_USER_DETAILS_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    tasksOptionsData = _useQuery5.data,
    tasksOptionsError = _useQuery5.error,
    tasksOptionsLoading = _useQuery5.loading;
  var selectedTeamIds = [];
  var userDetails = !tasksOptionsLoading && !tasksOptionsError ? tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get = tasksOptionsData.getProjectUserDetails) === null || _tasksOptionsData$get === void 0 ? void 0 : _tasksOptionsData$get.teamUserList : null;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _React$useState21 = React.useState(null),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    activeProjectId = _React$useState22[0],
    setActiveProjectId = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    keyData = _React$useState24[0],
    setKeyData = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isCheck = _React$useState26[0],
    setIsCheck = _React$useState26[1];
  var _React$useContext4 = React.useContext(UserContext),
    userContext = _React$useContext4.user;
  var _React$useState27 = React.useState([userContext === null || userContext === void 0 ? void 0 : userContext.userId]),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    userActive = _React$useState28[0],
    setUserActive = _React$useState28[1];
  var _React$useState29 = React.useState(""),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    searchUser = _React$useState30[0],
    setSearchUser = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    projectPlanStatus = _React$useState32[0],
    setProjectPlanStatus = _React$useState32[1];
  var _React$useState33 = React.useState(""),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    projectCreateError = _React$useState34[0],
    setProjectCreateError = _React$useState34[1];
  React.useEffect(function () {
    if (modalType === "editProject") {
      var _tasksOptionsData$get2, _tasksOptionsData$get3;
      var userArray = [];
      tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get2 = tasksOptionsData.getProjectUserDetails) === null || _tasksOptionsData$get2 === void 0 ? void 0 : (_tasksOptionsData$get3 = _tasksOptionsData$get2.teamSelectedUserList) === null || _tasksOptionsData$get3 === void 0 ? void 0 : _tasksOptionsData$get3.map(function (data) {
        userArray.push({
          userId: data.userId,
          teamId: data.teamId
        });
      });
      setUserActive(userArray);
    }
  }, [tasksOptionsData]);

  /**** Add New Project Submit  *****/
  var _useMutation = useMutation(ADD_NEW_PROJECT_DETAILS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addNewProjectDetails = _useMutation2[0],
    addNewProjectDetailsLoading = _useMutation2[1].loading;
  var handleProjectSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var projectName, variables, response, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            projectName = values.projectName;
            variables = {
              projectName: projectName,
              organisationId: organisationId,
              // headIds: projectManagers.length == 0 ? [user?.userId] : projectManagers,
              projectUsers: userActive
            };
            setProjectCreateError("");
            _context.prev = 3;
            _context.next = 6;
            return addNewProjectDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: MY_PROJECTS_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: userContext === null || userContext === void 0 ? void 0 : userContext.uniqueUrl,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  filter: "all",
                  role: role,
                  search: ""
                }
              }, {
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: userContext === null || userContext === void 0 ? void 0 : userContext.uniqueUrl,
                  role: role
                }
              }, {
                query: PROJECT_USER_DETAILS_DATA_QUERY,
                variables: {
                  organisationId: organisationId,
                  projectId: projectId
                }
              }, {
                query: MY_PROJECT_SUMMARY_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  role: role
                }
              }, {
                query: MY_PROJECT_HEADER_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  url: userContext === null || userContext === void 0 ? void 0 : userContext.uniqueUrl,
                  role: role
                }
              }]
            });
          case 6:
            response = _context.sent;
            if (!(!response || !response.data || response.data.addNewProjectDetails == null)) {
              _context.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            // setShowUserMap(true);
            // setActiveProjectId(response.data.addNewProjectDetails.projectId);
            toast.success("Project added successfully!");
            setActiveProjectId(null);
            setProjectPlanStatus(false);
            handleClose();
            history.push("/project-details/".concat(response.data.addNewProjectDetails.projectId));
          case 16:
            _context.next = 22;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](3);
            errorMessage = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || "";
            if (errorMessage.includes("already exist")) {
              actions.setFieldError("projectName", "Already Exists");
            } else if (errorMessage.includes("Exceed project count")) {
              setProjectPlanStatus(true);
              // toast.error("Please upgrade your plan to create new projects");
            } else if (errorMessage.includes("You’ve reached the limit")) {
              setProjectCreateError(errorMessage.replace("GraphQL error: ", ""));
            } else {
              setProjectCreateError("Something went wrong! Please try again later");
            }
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 18]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [addNewProjectDetails, addNewProjectDetailsLoading, userActive]);

  /**** Add New Project Submit END  *****/

  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  var projectManagersOnChange = function projectManagersOnChange(setFieldValue) {
    return function (selectedArray) {
      if (selectedArray && selectedArray.some(function (el) {
        return el.value === "everyone";
      })) {
        setFieldValue("projectManagers", ["everyone"]);
      } else if (selectedArray && selectedArray.some(function (el) {
        return el.value === "all teams";
      })) {
        setFieldValue("projectManagers", ["all teams"]);
      } else if (selectedArray && !selectedArray.some(function (el) {
        return el.value === "everyone" || el.value === "all teams";
      })) {
        setFieldValue("projectManagers", selectedArray.map(function (item) {
          return item.value;
        }));
      } else {
        setFieldValue("projectManagers", []);
      }
    };
  };
  var handleKey = function handleKey(key) {
    setKeyData(key);
    setIsCheck(function (prev) {
      return prev === true ? false : true;
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    size: "md",
    centered: true,
    className: "my-projects-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, modalType === "AddProject" ? "Create new project" : "Edit Project Details")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      projectName: modalType === "editProject" ? projectName : ""
    },
    validationSchema: projectSchema,
    onSubmit: handleProjectSubmit
  }, function (_ref4) {
    var _userWithSearch, _userWithSearch2;
    var setFieldValue = _ref4.setFieldValue,
      errors = _ref4.errors,
      touched = _ref4.touched,
      values = _ref4.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "my-projects-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "projectName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Project Name"), /*#__PURE__*/React.createElement("span", {
        className: "my-projects-modal-label-name-required"
      }, " *"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "e.g. Mobile App Design",
        className: "my-projects-edit-project-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-member-tasks-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-project-member-project-task-modals-user-label-section-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-project-member-project-task-modals-user-label-section my-projects-modal-label-name"
    }, "Choose Project Members"), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
      className: "project-member-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive([]);
      }
    }, "Unselect All Employees") : /*#__PURE__*/React.createElement("p", {
      //variant="outline-secondary"
      className: "project-member-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserActive(userIds);
      }
    }, "Select All Employees")), /*#__PURE__*/React.createElement("div", {
      className: "my-project-member-tasks-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-member-my-projects-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-project-task-modals-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchUser,
      onChange: setSearchUser,
      placeholder: "Search employee name"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "my-project-member-tasks-modal-content-person-name-listing"
    }, tasksOptionsLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
      var teamFirstName = user.displayName.match(/\b(\w)/g);
      var teamNameIcon = teamFirstName.join("");
      return /*#__PURE__*/React.createElement("div", {
        className: "project-member-project-task-modals-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-member-tasks-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          if (user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
            setUserActive(function (prev) {
              return prev.includes(user.userId) ? prev.filter(function (a) {
                return a !== user.userId;
              }) : [].concat(_toConsumableArray(prev), [user.userId]);
            });
          }
        }
      }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "project-member-task-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: user === null || user === void 0 ? void 0 : user.profileUrl,
        className: "project-member-task-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content-person-icon"
      }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "project-member-my-projects-modal-content-header-team-name"
      }, user.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "project-member-my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: user.userId,
        name: "myRadioGroup",
        className: "create-project-team-selection-control-checkbox",
        checked: user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? userActive.includes(user.userId) : true,
        disabled: user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? false : true,
        onChange: function onChange() {
          if (user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
            setUserActive(function (prev) {
              return prev.includes(user.userId) ? prev.filter(function (a) {
                return a !== user.userId;
              }) : [].concat(_toConsumableArray(prev), [user.userId]);
            });
          }
        }
      })));
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-muted text-center"
    }, "No member found for \"".concat(searchUser, "\" "))))), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, projectPlanStatus ? /*#__PURE__*/React.createElement("div", {
      className: "add-project-modal-button-rows-error"
    }, "Please upgrade your plan to create new project") : null)), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-save-button",
      type: "submit",
      disabled: addNewProjectDetailsLoading || projectPlanStatus
    }, addNewProjectDetailsLoading ? "Loading..." : "Create project")), projectCreateError ? /*#__PURE__*/React.createElement("div", {
      className: "add-project-modal-button-rows-error"
    }, projectCreateError) : null))))));
  })));
};
var TaskDeadlineModal = function TaskDeadlineModal(props) {
  var _taskDetailsData$getT4, _taskDetailsData$getT5, _taskDetailsData$getT6, _taskDetailsData$getT7;
  var taskDeadlineModalShow = props.taskDeadlineModalShow,
    handleCloseTaskDeadlineDetails = props.handleCloseTaskDeadlineDetails,
    timeZone = props.timeZone,
    organisationId = props.organisationId,
    role = props.role;
  if (taskDeadlineModalShow === null) {
    return null;
  }
  var _React$useState35 = React.useState("overdue"),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    taskDetailsActiveTab = _React$useState36[0],
    setTaskDetailsActiveTab = _React$useState36[1];
  var _React$useState37 = React.useState(true),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    isAllLoaded = _React$useState38[0],
    setIsAllLoaded = _React$useState38[1];
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    isLoadingMore = _React$useState40[0],
    setIsLoadingMore = _React$useState40[1];
  var _useLazyQuery = useLazyQuery(MY_PROJECT_TASK_DEADLINE, {
      fetchPolicy: "network-only"
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getTaskOverDueMyProject = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    taskDetailsData = _useLazyQuery2$.data,
    taskDetailsError = _useLazyQuery2$.error,
    taskDetailsLoading = _useLazyQuery2$.loading,
    taskDetailsFetchMore = _useLazyQuery2$.fetchMore;
  React.useEffect(function () {
    var _taskDetailsData$getT, _taskDetailsData$getT2;
    setIsAllLoaded((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getT = taskDetailsData.getTaskOverDueMyProject) === null || _taskDetailsData$getT === void 0 ? void 0 : _taskDetailsData$getT.length) != 0 && (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getT2 = taskDetailsData.getTaskOverDueMyProject) === null || _taskDetailsData$getT2 === void 0 ? void 0 : _taskDetailsData$getT2.length) < TASK_EMP_LIMIT ? true : false);
  }, [taskDetailsData]);

  // Run on modal open if active tab is "overdue"
  React.useEffect(function () {
    if (taskDeadlineModalShow && taskDetailsActiveTab === "overdue") {
      getTaskOverDueMyProject({
        variables: {
          organisationId: organisationId,
          timeZone: timeZone,
          limit: TASK_EMP_LIMIT,
          offset: 0,
          role: role,
          status: taskDetailsActiveTab
        }
      });
    }
  }, [taskDeadlineModalShow, taskDetailsActiveTab]);
  var handleLoadMore = function handleLoadMore() {
    var _taskDetailsData$getT3;
    // Prevent double calls during loading
    if (taskDetailsLoading || isLoadingMore || isAllLoaded) return;
    setIsLoadingMore(true);
    taskDetailsFetchMore({
      variables: {
        offset: (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getT3 = taskDetailsData.getTaskOverDueMyProject) === null || _taskDetailsData$getT3 === void 0 ? void 0 : _taskDetailsData$getT3.length) || 0
      },
      updateQuery: function updateQuery(prev, _ref5) {
        var fetchMoreResult = _ref5.fetchMoreResult;
        setIsLoadingMore(false);
        if (!fetchMoreResult || !fetchMoreResult.getTaskOverDueMyProject) {
          return prev;
        }

        // Mark as all loaded if no more data
        if (fetchMoreResult.getTaskOverDueMyProject.length === 0 || fetchMoreResult.getTaskOverDueMyProject.length < TASK_EMP_LIMIT) {
          setIsAllLoaded(true);
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          getTaskOverDueMyProject: [].concat(_toConsumableArray(prev.getTaskOverDueMyProject || []), _toConsumableArray(fetchMoreResult.getTaskOverDueMyProject || []))
        });
      }
    });
  };
  var handleTabSelect = function handleTabSelect(key) {
    setTaskDetailsActiveTab(key);
    getTaskOverDueMyProject({
      variables: {
        organisationId: organisationId,
        timeZone: timeZone,
        limit: TASK_EMP_LIMIT,
        offset: 0,
        role: role,
        status: key
      },
      fetchPolicy: "network-only",
      skip: taskDeadlineModalShow == null
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: taskDeadlineModalShow,
    onHide: handleCloseTaskDeadlineDetails,
    centered: true,
    size: "md",
    className: "task-deadline-modal-whole-div"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-deadline-modal-whole-div-title"
  }, "Task Deadlines", /*#__PURE__*/React.createElement("div", {
    className: "task-deadline-modal-whole-div-title-div"
  }, "Upcoming deadlines and overdue tasks"))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "task-deadline-modal-whole-div-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-deadline-modal-whole-div-body-tab-whole-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "overdue",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "overdue",
    title: "Overdue Tasks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container-overDue"
  }, taskDetailsLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskDetailsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : taskDetailsData.getTaskOverDueMyProject.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No data found!!!") : taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getT4 = taskDetailsData.getTaskOverDueMyProject) === null || _taskDetailsData$getT4 === void 0 ? void 0 : _taskDetailsData$getT4.map(function (projectCardValue, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-project"
    }, projectCardValue.projectName), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-task"
    }, projectCardValue.taskName), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-date"
    }, moment.unix(projectCardValue.dueDate / 1000).format("MMM DD, YYYY"))), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-crossed-text"
    }, projectCardValue.deadlineCrossedText));
  }), taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$getT5 = taskDetailsData.getTaskOverDueMyProject) !== null && _taskDetailsData$getT5 !== void 0 && _taskDetailsData$getT5.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data")) : null))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "upcoming",
    title: "Upcoming Overdue Tasks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container-overDue"
  }, taskDetailsLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskDetailsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : taskDetailsData.getTaskOverDueMyProject.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No data found!!!") : taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getT6 = taskDetailsData.getTaskOverDueMyProject) === null || _taskDetailsData$getT6 === void 0 ? void 0 : _taskDetailsData$getT6.map(function (projectCardValue, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-upcoming"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-project"
    }, projectCardValue.projectName), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-task"
    }, projectCardValue.taskName), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-date"
    }, moment.unix(projectCardValue.dueDate / 1000).format("MMM DD, YYYY"))), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-crossed-text"
    }, projectCardValue.deadlineCrossedText));
  }), taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$getT7 = taskDetailsData.getTaskOverDueMyProject) !== null && _taskDetailsData$getT7 !== void 0 && _taskDetailsData$getT7.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data")) : null)))))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleCloseTaskDeadlineDetails
  }, "Close")));
};
var ProjectDeadlineModal = function ProjectDeadlineModal(props) {
  var _taskDetailsData$getP4, _taskDetailsData$getP5, _taskDetailsData$getP6, _taskDetailsData$getP7;
  var projectDeadlineModalShow = props.projectDeadlineModalShow,
    handleCloseProjectDeadlineDetails = props.handleCloseProjectDeadlineDetails,
    timeZone = props.timeZone,
    organisationId = props.organisationId,
    role = props.role;
  if (projectDeadlineModalShow === null) {
    return null;
  }
  var _React$useState41 = React.useState("overdue"),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    projectDetailsActiveTab = _React$useState42[0],
    setProjectDetailsActiveTab = _React$useState42[1];
  var _React$useState43 = React.useState(true),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    isAllLoaded = _React$useState44[0],
    setIsAllLoaded = _React$useState44[1];
  var _React$useState45 = React.useState(false),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    isLoadingMore = _React$useState46[0],
    setIsLoadingMore = _React$useState46[1];
  var _useLazyQuery3 = useLazyQuery(MY_PROJECT_PROJECT_DEADLINE, {
      fetchPolicy: "network-only"
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getProjectOverDueMyProject = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    taskDetailsData = _useLazyQuery4$.data,
    taskDetailsError = _useLazyQuery4$.error,
    taskDetailsLoading = _useLazyQuery4$.loading,
    taskDetailsFetchMore = _useLazyQuery4$.fetchMore;
  React.useEffect(function () {
    var _taskDetailsData$getP, _taskDetailsData$getP2;
    setIsAllLoaded((taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getP = taskDetailsData.getProjectOverDueMyProject) === null || _taskDetailsData$getP === void 0 ? void 0 : _taskDetailsData$getP.length) != 0 && (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getP2 = taskDetailsData.getProjectOverDueMyProject) === null || _taskDetailsData$getP2 === void 0 ? void 0 : _taskDetailsData$getP2.length) < TASK_EMP_LIMIT ? true : false);
  }, [taskDetailsData]);

  // Run on modal open if active tab is "overdue"
  React.useEffect(function () {
    if (projectDeadlineModalShow && projectDetailsActiveTab === "overdue") {
      getProjectOverDueMyProject({
        variables: {
          organisationId: organisationId,
          timeZone: timeZone,
          limit: TASK_EMP_LIMIT,
          offset: 0,
          role: role,
          status: projectDetailsActiveTab
        }
      });
    }
  }, [projectDeadlineModalShow, projectDetailsActiveTab]);
  var handleLoadMore = function handleLoadMore() {
    var _taskDetailsData$getP3;
    // Prevent double calls during loading
    if (taskDetailsLoading || isLoadingMore || isAllLoaded) return;
    setIsLoadingMore(true);
    taskDetailsFetchMore({
      variables: {
        offset: (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getP3 = taskDetailsData.getProjectOverDueMyProject) === null || _taskDetailsData$getP3 === void 0 ? void 0 : _taskDetailsData$getP3.length) || 0
      },
      updateQuery: function updateQuery(prev, _ref6) {
        var fetchMoreResult = _ref6.fetchMoreResult;
        setIsLoadingMore(false);
        if (!fetchMoreResult || !fetchMoreResult.getProjectOverDueMyProject) {
          return prev;
        }

        // Mark as all loaded if no more data
        if (fetchMoreResult.getProjectOverDueMyProject.length === 0 || fetchMoreResult.getProjectOverDueMyProject.length < TASK_EMP_LIMIT) {
          setIsAllLoaded(true);
        }
        return _objectSpread(_objectSpread({}, prev), {}, {
          getProjectOverDueMyProject: [].concat(_toConsumableArray(prev.getProjectOverDueMyProject || []), _toConsumableArray(fetchMoreResult.getProjectOverDueMyProject || []))
        });
      }
    });
  };
  var handleTabSelect = function handleTabSelect(key) {
    setProjectDetailsActiveTab(key);
    getProjectOverDueMyProject({
      variables: {
        organisationId: organisationId,
        timeZone: timeZone,
        limit: TASK_EMP_LIMIT,
        offset: 0,
        role: role,
        status: key
      },
      fetchPolicy: "network-only",
      skip: projectDeadlineModalShow == null
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: projectDeadlineModalShow,
    onHide: handleCloseProjectDeadlineDetails,
    centered: true,
    size: "md",
    className: "task-deadline-modal-whole-div"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-deadline-modal-whole-div-title"
  }, "Project Deadlines", /*#__PURE__*/React.createElement("div", {
    className: "task-deadline-modal-whole-div-title-div"
  }, "Upcoming deadlines and overdue projects"))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "task-deadline-modal-whole-div-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-deadline-modal-whole-div-body-tab-whole-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "overdue",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "overdue",
    title: "Overdue Projects"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container-overDue"
  }, taskDetailsLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskDetailsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : taskDetailsData.getProjectOverDueMyProject.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No data found!!!") : taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getP4 = taskDetailsData.getProjectOverDueMyProject) === null || _taskDetailsData$getP4 === void 0 ? void 0 : _taskDetailsData$getP4.map(function (projectCardValue, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-project"
    }, projectCardValue.projectName), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-date"
    }, moment.unix(projectCardValue.dueDate / 1000).format("MMM DD, YYYY"))), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-crossed-text"
    }, projectCardValue.deadlineCrossedText));
  }), taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$getP5 = taskDetailsData.getProjectOverDueMyProject) !== null && _taskDetailsData$getP5 !== void 0 && _taskDetailsData$getP5.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data")) : null))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "upcoming",
    title: "Upcoming Overdue Projects"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-detail-task-detail-edit-modal-body-container-overDue"
  }, taskDetailsLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskDetailsError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, (taskDetailsData === null || taskDetailsData === void 0 ? void 0 : taskDetailsData.getProjectOverDueMyProject.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No data found!!!") : taskDetailsData === null || taskDetailsData === void 0 ? void 0 : (_taskDetailsData$getP6 = taskDetailsData.getProjectOverDueMyProject) === null || _taskDetailsData$getP6 === void 0 ? void 0 : _taskDetailsData$getP6.map(function (projectCardValue, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-upcoming"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-project"
    }, projectCardValue.projectName), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-date"
    }, moment.unix(projectCardValue.dueDate / 1000).format("MMM DD, YYYY"))), /*#__PURE__*/React.createElement("div", {
      className: "task-deadline-modal-whole-div-body-tab-whole-div-content-crossed-text"
    }, projectCardValue.deadlineCrossedText));
  }), taskDetailsData !== null && taskDetailsData !== void 0 && (_taskDetailsData$getP7 = taskDetailsData.getProjectOverDueMyProject) !== null && _taskDetailsData$getP7 !== void 0 && _taskDetailsData$getP7.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button-myproject-deadline-modal"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the data")) : null)))))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleCloseProjectDeadlineDetails
  }, "Close")));
};
var AddTaskModal = function AddTaskModal(props) {
  var _userWithSearch3, _userWithSearch4;
  var addTaskShow = props.addTaskShow,
    setAddTaskShow = props.setAddTaskShow,
    handleTaskClose = props.handleTaskClose,
    organisationId = props.organisationId,
    teamId = props.teamId,
    startDate = props.startDate,
    endDate = props.endDate,
    timeZone = props.timeZone,
    pageType = props.pageType,
    projectId = props.projectId;
  if (addTaskShow == null) {
    return null;
  }
  var _React$useContext5 = React.useContext(FilterContext),
    organisationSettings = _React$useContext5.organisationSettings,
    role = _React$useContext5.role;
  var _React$useState47 = React.useState([]),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    userActive = _React$useState48[0],
    setUserActive = _React$useState48[1];
  var _React$useState49 = React.useState(""),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    searchUser = _React$useState50[0],
    setSearchUser = _React$useState50[1];
  var _React$useState51 = React.useState(true),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    isUserSelected = _React$useState52[0],
    setUserSelected = _React$useState52[1];
  var _React$useState53 = React.useState([]),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    adminUserIds = _React$useState54[0],
    setAdminUserIds = _React$useState54[1];
  var _React$useState55 = React.useState(null),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    manualStartDate = _React$useState56[0],
    setManualStartDate = _React$useState56[1];
  var _React$useState57 = React.useState(null),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    taskStartDate = _React$useState58[0],
    setTaskStartDate = _React$useState58[1];
  var _React$useState59 = React.useState(false),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    isManualDatePickerOpen = _React$useState60[0],
    setIsManualDatePickerOpen = _React$useState60[1];
  var _React$useState61 = React.useState(false),
    _React$useState62 = _slicedToArray(_React$useState61, 2),
    isAddAndCreate = _React$useState62[0],
    setIsAddAndCreate = _React$useState62[1];
  var _React$useState63 = React.useState(false),
    _React$useState64 = _slicedToArray(_React$useState63, 2),
    istaskDesErr = _React$useState64[0],
    setIstaskDesErr = _React$useState64[1];
  var _React$useState65 = React.useState(false),
    _React$useState66 = _slicedToArray(_React$useState65, 2),
    isCheck = _React$useState66[0],
    setIsCheck = _React$useState66[1];
  var _React$useState67 = React.useState(true),
    _React$useState68 = _slicedToArray(_React$useState67, 2),
    isPriorityCheck = _React$useState68[0],
    setIsPriorityCheck = _React$useState68[1];
  var _React$useState69 = React.useState("false"),
    _React$useState70 = _slicedToArray(_React$useState69, 2),
    isUserNavCheck = _React$useState70[0],
    setIsUserNavCheck = _React$useState70[1];
  var formRef = React.useRef();
  var _React$useContext6 = React.useContext(UserContext),
    user = _React$useContext6.user;
  var uniqueUrl = user === null || user === void 0 ? void 0 : user.uniqueUrl;
  var _useQuery6 = useQuery(PROJECT_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        url: uniqueUrl,
        role: role
      },
      skip: !organisationId || !uniqueUrl
    }),
    projectTabsData = _useQuery6.data,
    projectTabsError = _useQuery6.error,
    projectTabsLoading = _useQuery6.loading;
  var _useQuery7 = useQuery(TASK_USERS_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: projectId
      },
      skip: !organisationId
    }),
    usersData = _useQuery7.data,
    usersError = _useQuery7.error,
    usersLoading = _useQuery7.loading,
    usersRefetch = _useQuery7.refetch;
  React.useEffect(function () {
    if (usersData !== null && usersData !== void 0 && usersData.getTaskUserDetails) {
      var _usersData$getTaskUse;
      var selectedUserIds = usersData === null || usersData === void 0 ? void 0 : (_usersData$getTaskUse = usersData.getTaskUserDetails) === null || _usersData$getTaskUse === void 0 ? void 0 : _usersData$getTaskUse.map(function (team) {
        return team.userId;
      });
      setUserActive(selectedUserIds);
      if (role == "Member") {
        var _usersData$getTaskUse2;
        var adminList = usersData === null || usersData === void 0 ? void 0 : (_usersData$getTaskUse2 = usersData.getTaskUserDetails) === null || _usersData$getTaskUse2 === void 0 ? void 0 : _usersData$getTaskUse2.filter(function (user) {
          return user.role === "admin";
        });
        var adminIds = adminList ? adminList.map(function (user) {
          return user.userId;
        }) : [];
        //.map((user) => user.userId)
        setAdminUserIds(adminIds);

        // Merge arrays and remove duplicates
        var mergedIds = Array.from(new Set([].concat(_toConsumableArray(userActive), _toConsumableArray(adminIds))));

        // Update the state
        setUserActive(mergedIds);
      }
    }
  }, [usersData]);
  React.useEffect(function () {
    if (projectTabsData !== null && projectTabsData !== void 0 && projectTabsData.projectList) {
      var _projectTabsData$proj;
      var selectedUserIds = projectTabsData === null || projectTabsData === void 0 ? void 0 : (_projectTabsData$proj = projectTabsData.projectList) === null || _projectTabsData$proj === void 0 ? void 0 : _projectTabsData$proj.map(function (team) {
        return team.projectId;
      });
      setUserActive(selectedUserIds);
    }
  }, [projectTabsData]);
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getTaskUserDetails : null;
  var projectDetails = !projectTabsLoading && !projectTabsError ? projectTabsData === null || projectTabsData === void 0 ? void 0 : projectTabsData.projectList : null;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var projectIds = projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.map(function (user) {
    return user.userId;
  });
  var _useMutation3 = useMutation(ADD_TASK_DETAILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addTaskDetails = _useMutation4[0],
    addTaskDetailsLoading = _useMutation4[1].loading;
  var _useMutation5 = useMutation(ADD_USER_TASK_DETAILS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addUserTaskDetails = _useMutation6[0],
    addUserTaskDetailsLoading = _useMutation6[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var taskName, taskTime, priority, projectUsers, taskDescription, hasTaskNameDuplicate, variables, _response$data, response, _response$data2, _response$data3;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            taskName = values.taskName, taskTime = values.taskTime, priority = values.priority, projectUsers = values.projectUsers, taskDescription = values.taskDescription;
            hasTaskNameDuplicate = taskName.map(function (name) {
              return name.toLowerCase();
            }) // Normalize case
            .some(function (name, index, arr) {
              return arr.indexOf(name) !== index;
            });
            if (!hasTaskNameDuplicate) {
              _context2.next = 5;
              break;
            }
            actions.setFieldError("formError", "Task title must be unique!");
            return _context2.abrupt("return", false);
          case 5:
            // actions.setFieldError("formError", response?.data?.addTaskDetails);
            variables = {
              taskName: taskName,
              projectId: addTaskShow,
              organisationId: organisationId,
              taskTime: taskTime === null ? null : Number(taskTime) * 60 * 60,
              userId: isPriorityCheck ? userActive : [],
              dueDate: manualStartDate,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              priority: priority,
              startDate: taskStartDate,
              taskDescription: taskDescription
            };
            setIstaskDesErr(false);
            _context2.prev = 7;
            _context2.next = 10;
            return addTaskDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: MY_PROJECTS_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: uniqueUrl,
                  timeZone: timeZone,
                  limit: LIMIT,
                  offset: 0,
                  filter: "all",
                  role: role
                }
              }, {
                query: PROJECT_LISTING_QUERY,
                variables: {
                  organisationId: organisationId,
                  url: uniqueUrl,
                  role: role
                }
              }, {
                query: PROJECT_USER_DETAILS_DATA_QUERY,
                variables: {
                  organisationId: organisationId,
                  projectId: projectId
                }
              }, {
                query: MY_PROJECT_SUMMARY_QUERY,
                variables: {
                  organisationId: organisationId,
                  timeZone: timeZone,
                  role: role
                }
              }]
            });
          case 10:
            response = _context2.sent;
            if (response && (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.addTaskDetails) != "error") {
              if (isPriorityCheck) {
                toast.success("Task added successfully!");
                handleTaskClose();
              } else {
                setIsUserNavCheck(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.addTaskDetails);
              }
            } else {
              actions.setFieldError("formError", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.addTaskDetails);
            }
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](7);
            actions.setFieldError("formError", _context2.t0.message);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[7, 14]]);
    }));
    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }(), [addTaskDetails, addTaskDetailsLoading, manualStartDate, isAddAndCreate, taskStartDate, userActive, isPriorityCheck]);
  var handleUserSubmitButton = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var variables, _response$data4, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          variables = {
            projectId: addTaskShow,
            organisationId: organisationId,
            taskId: isUserNavCheck,
            userId: userActive
          };
          _context3.prev = 1;
          _context3.next = 4;
          return addUserTaskDetails({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: MY_PROJECTS_QUERY,
              variables: {
                organisationId: organisationId,
                url: uniqueUrl,
                timeZone: timeZone,
                limit: LIMIT,
                offset: 0,
                filter: "all",
                role: role
              }
            }, {
              query: PROJECT_LISTING_QUERY,
              variables: {
                organisationId: organisationId,
                url: uniqueUrl,
                role: role
              }
            }, {
              query: PROJECT_USER_DETAILS_DATA_QUERY,
              variables: {
                organisationId: organisationId,
                projectId: projectId
              }
            }, {
              query: MY_PROJECT_SUMMARY_QUERY,
              variables: {
                organisationId: organisationId,
                timeZone: timeZone,
                role: role
              }
            }]
          });
        case 4:
          response = _context3.sent;
          if (response && (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.addUserTaskDetails) == true) {
            toast.success("Task added successfully!");
            handleTaskClose();
          } else {
            setIstaskDesErr(true);
          }
          _context3.next = 11;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](1);
          setIstaskDesErr(true);
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 8]]);
  })), [addUserTaskDetails, addUserTaskDetailsLoading, userActive, isPriorityCheck, isUserNavCheck]);
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp5, _filterUsersData$disp6, _filterUsersData$disp7, _filterUsersData$disp8;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp5 = filterUsersData.displayName) === null || _filterUsersData$disp5 === void 0 ? void 0 : (_filterUsersData$disp6 = _filterUsersData$disp5.toLowerCase) === null || _filterUsersData$disp6 === void 0 ? void 0 : (_filterUsersData$disp7 = _filterUsersData$disp6.call(_filterUsersData$disp5)) === null || _filterUsersData$disp7 === void 0 ? void 0 : (_filterUsersData$disp8 = _filterUsersData$disp7.includes) === null || _filterUsersData$disp8 === void 0 ? void 0 : _filterUsersData$disp8.call(_filterUsersData$disp7, searchUser.toLowerCase());
    });
  };
  var handleChange = function handleChange(e) {
    setIsManualDatePickerOpen(!isManualDatePickerOpen);
    setManualStartDate(e);
  };
  var handleKey = function handleKey(data) {
    if (data == "setting") {
      setIsCheck(function (prev) {
        return prev === true ? false : true;
      });
    } else if (data == "private") {
      setIsPriorityCheck(function (prev) {
        return prev === true ? false : true;
      });
    }
  };
  var errorMessage = function errorMessage(errors, touched, name) {
    var error = getIn(errors, name);
    var touch = getIn(touched, name);
    if (touch && error) {
      return /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, error);
    }
    return null;
  };
  var CustomInputTextAreaComponent = function CustomInputTextAreaComponent(props) {
    return /*#__PURE__*/React.createElement("input", _extends({
      className: "my-custom-input",
      type: "textarea"
    }, props));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleTaskClose,
    centered: true,
    className: "project-task-modals-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, isUserNavCheck == "false" ? "Create New Task" : "Assign Task To")), /*#__PURE__*/React.createElement(Modal.Body, null, isUserNavCheck == "false" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      taskName: [""],
      taskTime: "",
      priority: "",
      projectUsers: [],
      taskDescription: ""
    }
    //validationSchema={TaskSchema}
    ,
    enableReinitialize: true,
    onSubmit: handleSubmit,
    innerRef: formRef
  }, function (_ref9) {
    var setFieldValue = _ref9.setFieldValue,
      errors = _ref9.errors,
      values = _ref9.values,
      touched = _ref9.touched,
      field = _ref9.field;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "tasks-modal-cols"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "project-task-modals-edit-task-label-name"
    }, "Task title ", /*#__PURE__*/React.createElement("sup", {
      className: "project-task-modals-edit-task-label-name-star"
    }, "*")), /*#__PURE__*/React.createElement(FieldArray, {
      name: "taskName",
      render: function render(taskArrayHelpers) {
        var _values$taskName;
        return /*#__PURE__*/React.createElement(React.Fragment, null, values === null || values === void 0 ? void 0 : (_values$taskName = values.taskName) === null || _values$taskName === void 0 ? void 0 : _values$taskName.map(function (task, taskIndex) {
          var teamError = errorMessage(errors, touched, "taskName[".concat(taskIndex, "]"));
          return /*#__PURE__*/React.createElement("div", {
            className: "create-new-task-whole-div-new"
          }, /*#__PURE__*/React.createElement("div", {
            className: "create-new-task-whole-div-new-textbox"
          }, /*#__PURE__*/React.createElement(FormGroup, null, teamError, /*#__PURE__*/React.createElement(Field, {
            as: Form.Control,
            type: "text",
            name: "taskName[".concat(taskIndex, "]"),
            value: task,
            required: true,
            placeholder: "e.g. Research and Analysis",
            isInvalid: teamError != null,
            className: "form-control"
          }))), /*#__PURE__*/React.createElement("div", {
            className: ""
          }, values.taskName.length !== 1 ? /*#__PURE__*/React.createElement(Button, {
            variant: "outline-secondary",
            className: "create-new-task-whole-div-new-button",
            size: "md",
            onClick: function onClick() {
              return taskArrayHelpers.remove(taskIndex);
            }
          }, "-") : /*#__PURE__*/React.createElement(Button, {
            variant: "outline-secondary",
            className: "create-new-task-whole-div-new-button",
            size: "md",
            disabled: true
          }, "-")));
        }), /*#__PURE__*/React.createElement("div", {
          className: "employee-row justify-content-md-center"
        }, /*#__PURE__*/React.createElement(Button, {
          className: "create-new-task-whole-div-add-new-team",
          variant: "link",
          onClick: function onClick() {
            return taskArrayHelpers.push("");
          }
        }, "+ Add more task")));
      }
    }), /*#__PURE__*/React.createElement(Field, {
      name: "project"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "project-task-section-whole-input-div"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Project Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        defaultValue: "",
        required: true
      }, field), /*#__PURE__*/React.createElement("option", {
        value: null
      }, "None"), taskPriority === null || taskPriority === void 0 ? void 0 : taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "taskDescription"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-task-modals-add-task-label-name-task-description"
      }, /*#__PURE__*/React.createElement("label", {
        className: "my-projects-modal-label-name"
      }, values.taskName.length > 1 ? "Task description for all tasks" : "Task description"), /*#__PURE__*/React.createElement("textarea", _extends({
        className: "text-area"
      }, field, fieldProps)), meta.touched && meta.error ? /*#__PURE__*/React.createElement("div", {
        className: "error"
      }, meta.error) : null);
    }), /*#__PURE__*/React.createElement("div", {
      className: "task-modal-private-toggle-div"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "project-tasks-modal-content-header-setting"
    }, /*#__PURE__*/React.createElement(HiLockClosed, {
      className: "project-tasks-modal-content-header-setting-icon"
    }), " Assign this task to all members in the project"), /*#__PURE__*/React.createElement("div", {
      className: "task-modal-private-toggle-div-command-line"
    }, "You can assign the selective members to this task by unselecting this option")), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch",
      onClick: function onClick() {
        return handleKey("private");
      }
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": isPriorityCheck
      })
    })))), /*#__PURE__*/React.createElement(Accordion, {
      className: "task-modal-accordion-whole"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handleKey("setting");
      }
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
      as: Button,
      variant: "link",
      eventKey: "0",
      className: "task-modal-content-header-team-name-acc"
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-tasks-modal-content-header-setting"
    }, isCheck ? "Hide advanced settings" : "Show advanced settings"), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch"
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": isCheck
      })
    }))))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-acc-collapse-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-date-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
      name: "taskTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "project-task-section-whole-input-div"
        //className="my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Estimated Time (Optional)"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "project-tasks-modals-add-time-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        min: "0",
        placeholder: "e.g. 10",
        className: "task-add-placeholder"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "project-task-modal-add-new-project-hours-text"
      }, "Hours")));
    })), /*#__PURE__*/React.createElement("div", {
      className: "project-task-due-date"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "project-task-modals-edit-task-label-name"
    }, "Due Date (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-due-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualStartDate,
      onChange: handleChange,
      isClearable: true,
      className: "task-details-due-date-date-picker",
      placeholderText: "Select due date",
      autoComplete: "off"
      // open={isManualDatePickerOpen}
      // inline
    }))), /*#__PURE__*/React.createElement("div", {
      className: "task-priority-whole-div-data"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-add-modal-priority-div"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "priority"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "project-task-section-whole-input-div"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Priority"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        as: "select",
        defaultValue: "",
        required: true
      }, field), /*#__PURE__*/React.createElement("option", {
        value: null
      }, "None"), taskPriority === null || taskPriority === void 0 ? void 0 : taskPriority.map(function (task) {
        return /*#__PURE__*/React.createElement("option", {
          value: task.value
        }, task.label);
      })));
    })))))))), /*#__PURE__*/React.createElement(Row, {
      className: ""
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-list-modal-save-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "project-task-modals-save-button",
      type: "submit",
      disabled: addTaskDetailsLoading && isAddAndCreate == false
    }, addTaskDetailsLoading && isAddAndCreate == false ? "Loading..." : "Add Task"), " "), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "form-error my-projects-modal-form-error"
    }, errors.formError) : null)))));
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search employee name"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-user-label-section-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-user-label-section"
  }, "Project members"), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      if (role == "Member") {
        setUserActive(adminUserIds);
      } else {
        setUserActive([]);
      }
      setUserSelected(true);
    }
  }, "Unselect All Employees") : /*#__PURE__*/React.createElement("p", {
    //variant="outline-secondary"
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive(userIds);
      setUserSelected(true);
    }
  }, "Select All Employees")), /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-listing"
  }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch3 = userWithSearch(userDetails)) !== null && _userWithSearch3 !== void 0 && _userWithSearch3.length ? (_userWithSearch4 = userWithSearch(userDetails)) === null || _userWithSearch4 === void 0 ? void 0 : _userWithSearch4.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person",
      onClick: function onClick() {
        if (role != "Member" || role == "Member" && !adminUserIds.includes(user.userId)) {
          setUserSelected(true);
          setUserActive(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      }
    }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-header-team-name"
    }, user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-team-name"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      disabled: role == "Member" && adminUserIds.includes(user.userId),
      onChange: function onChange() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    })));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\" ")))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-task-modals-save-button",
    onClick: function onClick() {
      handleUserSubmitButton();
    },
    disabled: addUserTaskDetailsLoading && isAddAndCreate == false
  }, addUserTaskDetailsLoading && isAddAndCreate == false ? "Loading..." : "Done")))));
};
export default MyProjects;

// const MyProjects = (props) => {
//   const Link = props.linkComponent;
//   const linkProps = props.linkProps;
//   const history = props?.history;

//   const [projectModalShow, setShow] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = React.useState(null);

//   const [isAllLoaded, setIsAllLoaded] = React.useState(false);
//   const [isLoadingMore, setIsLoadingMore] = useState(false);
//   const [isLoadMoreButton, setIsLoadMoreButton] = useState(false);
//   const [addedProjectId, setAddedProjectId] = useState(null);
//   const [showUserMap, setShowUserMap] = React.useState(false);
//   const [isEstimationHover, setEstimationHover] = React.useState(null);
//   const [projectEstimationTime, addProjectEstimationTime] = React.useState("");

//   const [filterId, setFilterId] = useState("all");
//   const [isCurrentlyWorkingLoaded, setIsCurrentlyWorkingLoaded] = useState(false);
//   const [isOverWorkLoaded, setIsOverWorkLoaded] = useState(false);
//   const [isTodayWorkLoaded, setIsTodayWorkLoaded] = useState(false);
//   const [isArchivedLoaded, setIsArchivedLoaded] = useState(false);
//   const [isDeadlineLoaded, setIsDeadlineLoaded] = useState(false);

//   const [isGettingData, setIsGettingData] = useState(false);
//   const [refetchStatus, setRetchStatus] = useState(false);

//   //  WORKFOLIO MAINTENANCE REDIRECTION
//   // React.useEffect(() => {
//   //   props?.history.push("/workfolio-maintenance");
//   // }, []);

//   const {
//     teamId,
//     organisationId,
//     startDate,
//     endDate,
//     organisationSettings,
//     role,
//     organisationBilling,
//     from,
//     organisationStatus,
//   } = React.useContext(FilterContext);

//   // React.useEffect(() => {
//   //   if (from == "web" && role == "Member") {
//   //     props?.history.push("/my-work");
//   //   }
//   // }, [role]);

//   React.useEffect(() => {
//     if (
//       organisationBilling?.planId == null ||
//       organisationBilling?.planStatus === "stopped" ||
//       organisationStatus == "inactive"
//     ) {
//       props?.history.push("/billing");
//     }
//   }, [organisationBilling]);

//   React.useEffect(() => {
//     if (role === "Member" && !organisationSettings.projectManagementFeature) {
//       props?.history.push("/my-work");
//     }
//   }, [role]);

//   const { search: projectSearch } = React.useContext(SearchContext);

//   const { user } = React.useContext(UserContext);

//   const dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings?.organisationTimezone);

//   const organisationDetails = user?.organisations?.find((organisation) => organisation.id === organisationId) || {};
//   const teamDatas = organisationDetails?.teams?.find((team) => team.id === teamId) || {};
//   // const role = teamDatas?.role?.roleName;

//   const handleClose = () => {
//     setShow(null);
//     setShowUserMap(false);
//   };
//   const handleShow = (
//     modalType,
//     teamDetails,
//     projectName,
//     projectId,
//     selectedTeam,
//     estimatedTime,
//     projectSelectedHeadList
//   ) => {
//     const temp = {
//       modalType,
//       teamDetails,
//       organisationId,
//       projectName,
//       projectId,
//       selectedTeam,
//       teamId,
//       startDate,
//       endDate,
//       estimatedTime,
//       projectSelectedHeadList,
//     };
//     setShow(temp);
//   };
//   const handleDeleteClose = () => setShowDeleteModal(null);
//   const handleDeleteShow = (projectName, projectId, organisationId, teamDetails, teamId) => {
//     const temp = { projectName, projectId, organisationId, teamDetails, teamId, startDate, endDate };
//     setShowDeleteModal(temp);
//   };

//   const startTime = Number(moment(startDate).format("x"));
//   const endTime = Number(moment(endDate ?? startDate).format("x"));

//   const {
//     data: myProjectHeaderData,
//     error: myProjectHeaderError,
//     loading: myProjectHeaderLoading,
//     refetch,
//   } = useQuery(MY_PROJECT_HEADER_QUERY, {
//     variables: {
//       organisationId,
//       timeZone: organisationSettings?.organisationTimezone,
//       url: user?.uniqueUrl,
//       role,
//     },
//     skip: !organisationId,
//   });

//   const {
//     data: myProjectsData,
//     error: myProjectsError,
//     loading: myProjectsLoading,
//     refetch: myProjectsRefetch,
//     fetchMore,
//   } = useQuery(MY_PROJECTS_QUERY, {
//     variables: {
//       organisationId,
//       url: user?.uniqueUrl,
//       // startDate: Number(moment(startDate).format("x")),
//       // endDate: Number(moment(endDate ?? startDate).format("x")),
//       timeZone: organisationSettings?.organisationTimezone,
//       limit: LIMIT,
//       offset: 0,
//       filter: filterId,
//       role,
//     },
//     skip: !organisationId || !teamId,
//     // fetchPolicy: "cache-and-network",
//   });

//   const {
//     data: teamsData,
//     error: teamsError,
//     loading: teamsLoading,
//     refetch: teamsRefetch,
//   } = useQuery(ORGANISATION_TEAMS_QUERY, {
//     variables: {
//       organisationId,
//     },
//     skip: !organisationId,
//   });

//   const [updateProjectEstimateTime, { loading: updateProjectEstimateTimeLoading }] = useMutation(
//     UPDATE_PROJECT_ESTIMATED_TIME_MUTATION
//   );

//   const handleSubmit = React.useCallback(async () => {
//     if (!isEstimationHover || projectEstimationTime == "" || projectEstimationTime == null) {
//       setEstimationHover(null);
//       addProjectEstimationTime("");
//       return null;
//     }

//     const variables = {
//       projectId: isEstimationHover.projectId,
//       projectTime: projectEstimationTime ? Number(projectEstimationTime) * 60 * 60 : 0,
//       organisationId: organisationId,
//     };

//     try {
//       const response = await updateProjectEstimateTime({
//         variables,
//         awaitRefetchQueries: true,
//         refetchQueries: [
//           {
//             query: MY_PROJECTS_QUERY,
//             variables: {
//               organisationId,
//               url: user?.uniqueUrl,
//               timeZone: organisationSettings?.organisationTimezone,
//               limit: LIMIT,
//               offset: 0,
//               filter: filterId,
//               role,
//             },
//           },
//         ],
//       });

//       if (!response || !response.data || response.data.updateProjectEstimatedTime == null) {
//         throw new Error("error");
//       } else {
//         toast.success("Estimated Time added successfully!");
//         setEstimationHover(null);
//         addProjectEstimationTime("");
//       }
//     } catch (error) {
//       console.log(error);
//       toast.success("Error Occured, Try again latter!");
//     }
//   }, [updateProjectEstimateTime, updateProjectEstimateTimeLoading, projectEstimationTime, isEstimationHover]);

//   React.useEffect(() => {
//     allOffsets = 0;
//     currentlyWorkingoffsets = 0;
//     overWorkOffsets = 0;
//     todayWorkOffsets = 0;
//     archivedOffsets = 0;

//     setRetchStatus(true);
//     setIsAllLoaded(false);
//     setIsCurrentlyWorkingLoaded(false);
//     setIsOverWorkLoaded(false);
//     setIsTodayWorkLoaded(false);
//     setIsArchivedLoaded(false);
//     setIsDeadlineLoaded(false);
//     refetch?.();
//     myProjectsRefetch?.();
//     teamsRefetch?.();
//   }, [props.location.key]);

//   React.useEffect(() => {
//     if (myProjectsData && !myProjectsLoading) {
//       setIsGettingData(true);
//       setRetchStatus(false);
//     }
//   }, [myProjectsData]);

//   React.useEffect(() => {
//     if (
//       myProjectsData?.myProjects?.projectsData?.length !== 0 &&
//       myProjectsData?.myProjects?.projectsData?.length < LIMIT
//     ) {
//       if (filterId == "all") {
//         setIsAllLoaded(true);
//       } else if (filterId == "start") {
//         setIsCurrentlyWorkingLoaded(true);
//       } else if (filterId == "over") {
//         setIsOverWorkLoaded(true);
//       } else if (filterId == "todayWork") {
//         setIsTodayWorkLoaded(true);
//       }
//       else if(filterId == "archived"){
//         setIsArchivedLoaded(true);
//       }
//       else if(filterId == "deadline"){
//         setIsDeadlineLoaded(true);
//       }
//     }
//   }, [myProjectsData?.myProjects?.projectsData, filterId, props.location.key]);

//   React.useEffect(() => {
//     myProjectsRefetch?.();
//   }, [filterId]);

//   if (myProjectHeaderLoading) {
//     return <Loader />;
//   }

//   if (myProjectHeaderError) {
//     return <div>Error</div>;
//   }

//   if (!myProjectHeaderData) {
//     return <div>No data</div>;
//   }

//   const projectStatusCountData = myProjectHeaderData?.myProjectHeader?.projectStatusCount;

//   const teamDetails = !teamsLoading && !teamsError ? teamsData?.organisationTeams : null;

//   const projectWithSearch = (projectsData) => {
//     if (!projectSearch) {
//       return projectsData;
//     }
//     return projectsData.filter((filterProjectsData) =>
//       filterProjectsData?.displayName?.toLowerCase?.()?.includes?.(projectSearch.toLowerCase())
//     );
//   };

//   const isDemoOrLiveSite = findDemoOrLiveSite();

//   const addButtonBasedOnRole = true;

//   const getOffsetValue = () => {
//     if (filterId == "all" && isGettingData) {
//       setIsAllLoaded(true);
//     } else if (filterId == "start" && isGettingData) {
//       setIsCurrentlyWorkingLoaded(true);
//     } else if (filterId == "over" && isGettingData) {
//       setIsOverWorkLoaded(true);
//     } else if (filterId == "todayWork" && isGettingData) {
//       setIsTodayWorkLoaded(true);
//     }
//     else if (filterId == "archived" && isGettingData) {
//       setIsArchivedLoaded(true);
//     }
//     else if (filterId == "deadline" && isGettingData) {
//       setIsDeadlineLoaded(true);
//     }
//   };
//   const getOffsetValueFalse = (value) => {
//     if (value == "all" && !isAllLoaded) {
//       setIsAllLoaded(false);
//     } else if (value == "start") {
//       setIsCurrentlyWorkingLoaded(false);
//     } else if (value == "over" && !isOverWorkLoaded) {
//       setIsOverWorkLoaded(false);
//     } else if (value == "todayWork" && !isTodayWorkLoaded) {
//       setIsTodayWorkLoaded(false);
//     }
//     else if (value == "archived" && !isArchivedLoaded) {
//       setIsArchivedLoaded(false);
//     }
//     else if(value == "deadline" && !isDeadlineLoaded ){
//       setIsDeadlineLoaded(false);
//     }
//   };

//   const handleLoadMore = () => {
//     if (myProjectsLoading) return;
//     setIsLoadingMore(true);

//     let offsets = 0;
//     if (filterId == "all") {
//       allOffsets = allOffsets + 1;
//       offsets = allOffsets;
//     } else if (filterId == "start") {
//       currentlyWorkingoffsets = currentlyWorkingoffsets + 1;
//       offsets = currentlyWorkingoffsets;
//     } else if (filterId == "over") {
//       overWorkOffsets = overWorkOffsets + 1;
//       offsets = overWorkOffsets;
//     } else if (filterId == "todayWork") {
//       todayWorkOffsets = todayWorkOffsets + 1;
//       offsets = todayWorkOffsets;
//     } else if(filterId == "archived") {
//       archivedOffsets = archivedOffsets + 1;
//       offsets = archivedOffsets;
//     }
//     else if(filterId == "deadline"){
//       deadlineOffsets = deadlineOffsets + 1;
//       offsets = deadlineOffsets
//     }

//     fetchMore({
//       variables: {
//         offset: offsets * LIMIT,
//       },

//       updateQuery: (prev, { fetchMoreResult }) => {
//         if (!fetchMoreResult) return prev;
//         if (
//           (fetchMoreResult?.myProjects?.projectsData?.length === 0 &&
//             fetchMoreResult.myProjects?.projectsData.length < LIMIT) ||
//           (fetchMoreResult?.myProjects?.projectsData?.length !== 0 &&
//             fetchMoreResult.myProjects.projectsData.length < LIMIT)
//         ) {
//           getOffsetValue();
//         }
//         setIsLoadingMore(false);

//         return {
//           ...prev,
//           myProjects: {
//             ...prev.myProjects,
//             projectsData: [...prev.myProjects?.projectsData, ...fetchMoreResult.myProjects?.projectsData],
//           },
//         };
//       },
//     });
//   };

//   // React.useEffect(() => {
//   //   if (!organisationSettings.projectManagementFeature) {
//   //     return <ProjectEnableSection />;
//   //   }
//   // }, [organisationSettings]);

//   return (
//     <div className="my-projects-root">
//       {/* <WorkSummary
//         myProjectSummary={myProjectSummaryData?.myProjectSummary?.projectSummary}
//         history={history}
//         dateFilter={dateFilter}
//       /> */}
//       {/* {Number(myProjectSummaryData?.myProjectSummary?.projectSummary?.projectsEnabledTo) <= 0 ? (
//         <AddMemberCard history={history} displayName={user?.displayName} />
//       ) : null} */}
//       {!organisationSettings.projectManagementFeature ? (
//         <ProjectEnableSection
//           user={user}
//           organisationId={organisationId}
//           organisationSettings={organisationSettings}
//           filterId={filterId}
//           role={role}
//           pageName={"my-projects"}
//           isTaskViewCheck={null}
//           teamId={null}
//           projectIds={null}
//           taskIds={null}
//           planName={null}
//           last14Days={null}
//           from={null}
//           propsUserId={null}
//           userIds={null}
//           userActive={null}
//           projectActive={null}
//           taskActive={null}
//           startDate={null}
//           endDate={null}
//           projectId={null}
//           userUrl={null}
//         />
//       ) : (
//         <>
//           {projectStatusCountData[0]?.count != 0 ? (
//             <div className="my-projects-root-header">
//               <div className="my-projects-root-filter-button">
//                 {projectStatusCountData.map((item) => {
//                   return (
//                     <>
//                     {organisationBilling?.planName == "free" && item.value == "archived" ?  null:
//                     <Button
//                       variant=" "
//                       className={`rounded-pill px-3 my-project-status-filter ${
//                         filterId === item.value ? "my-projects-status-filter-selected" : null
//                       }`}
//                       size="sm"
//                       onClick={() => {
//                         setFilterId(item.value);
//                         getOffsetValueFalse(item.value);
//                         setIsGettingData(false);
//                       }}
//                     >
//                       {item.label} {item.count > 0 ? `(${item.count})` : ""}
//                     </Button>}
//                     </>
//                   );
//                 })}
//               </div>

//               {role != "Member" ? (
//                 <div className="add-projects-button">
//                   <>
//                     {Number(myProjectsData?.myProjects?.totalProjectCount) >= 2 &&
//                     organisationBilling.planName == "free" ? (
//                       <OverlayTrigger
//                         placement="bottom"
//                         overlay={
//                           <Tooltip id={`tooltip-bottom`} className="count-tooltip-start">
//                             Please upgrade your plan to create projects
//                           </Tooltip>
//                         }
//                       >
//                         <div className="Teams-root-header-left-side-button upgrade-plan-button-color">
//                           Create Project
//                         </div>
//                       </OverlayTrigger>
//                     ) : (
//                       <Button
//                         variant="primary"
//                         className="font-weight-bold"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleShow("AddProject", teamDetails);
//                         }}
//                         disabled={organisationBilling.planName == "free" && !myProjectsData}
//                       >
//                         Create Project
//                       </Button>
//                     )}
//                   </>
//                 </div>
//               ) : null}
//             </div>
//           ) : null}

//           {myProjectsLoading ? (
//             <Loader />
//           ) : myProjectsError ? (
//             <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>
//           ) : myProjectsData?.myProjects?.projectsData?.length ? (
//             <>
//               <div className="project-card-root">
//                 {myProjectsData?.myProjects?.projectsData?.length === 0 ? (
//                   <div className="no-data">No Projects found</div>
//                 ) : !projectWithSearch(myProjectsData?.myProjects?.projectsData)?.length ? (
//                   <div className="text-muted text-center">{`No projects found for "${projectSearch}"
//             `}</div>
//                 ) : (
//                   projectWithSearch(myProjectsData?.myProjects?.projectsData).map((projectCardValue, index) => {
//                     let assignedTo = "";
//                     let assignedToAll = "";
//                     let userCount = 0;

//                     projectCardValue?.recentProjectUser.map((recent) => {
//                       assignedTo += userCount == 0 ? recent.user.displayName : "";
//                       assignedToAll += userCount == 0 ? recent.user.displayName : ", " + recent.user.displayName;
//                       userCount++;
//                     });

//                     if (userCount > 1) {
//                       assignedTo += " & " + (userCount - 1) + " Others";
//                       //assignedTo = assignedTo.length > 16 ? userCount + " Members" : assignedTo;
//                     }

//                     const trimDisplayName = projectCardValue.displayName.trim();

//                     return (
//                       <div
//                         className={`position-relative project-card-div-wrapper ${
//                           projectCardValue.recentProjectDateText == " worked today"
//                             ? "project-card-div-wrapper-today"
//                             : null
//                         }`}
//                         key={projectCardValue.projectId}
//                       >
//                         <Link
//                           {...{
//                             [linkProps]: `/project-details/${projectCardValue.projectId}`,
//                           }}
//                           className={classNames("project-card d-block  white", projectCardValue?.currentWorkStatus)}
//                         >
//                           <div className="d-flex align-items-center project-card-project-name-div">
//                             <div className="d-flex flex-grow-1">
//                               {/* <div className="project-card-avatar">{trimDisplayName.charAt(0).toUpperCase()}</div> */}
//                               <div>
//                                 <OverlayTrigger
//                                   overlay={<Tooltip id="tooltip-project-name">{projectCardValue.displayName}</Tooltip>}
//                                 >
//                                   <div className="project-card-projectname flex-grow-1">
//                                     {projectCardValue.displayName}
//                                   </div>
//                                 </OverlayTrigger>
//                               </div>
//                             </div>
//                           </div>

//                           <div
//                             className="project-card-footer-chart"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               history.push(`/project-details/${projectCardValue.projectId}`);
//                             }}
//                           >
//                             <div className="project-card-total-worked-time">
//                               <MdAccessTime className="project-card-total-worked-time-icon" />
//                               <div>{projectCardValue.projectTotalWorkedTime}</div>
//                             </div>
//                             <div className="project-card-total-task-count">
//                               <div>
//                                 {projectCardValue.taskCount > 0
//                                   ? `${projectCardValue.taskCount} tasks`
//                                   : `${projectCardValue.taskCount} task`}
//                               </div>
//                             </div>
//                           </div>
// {projectCardValue?.deadlineCrossedText == null ?
//                           <OverlayTrigger
//                             key={`currently-working`}
//                             placement={"bottom"}
//                             overlay={
//                               <Tooltip id={`tooltip-bottom`} className="count-tooltip-start">
//                                 <div className="count-tooltip-whole">
//                                   {projectCardValue?.recentProjectUser.length !== 0 ? (
//                                     <>
//                                       {projectCardValue?.recentProjectUser.slice(0, 15).map((data, key) => {
//                                         return (
//                                           <div className="count-tooltip-header">
//                                             <img
//                                               alt="Workfolio"
//                                               src={data.user.profileUrl ? data.user.profileUrl : Profiles}
//                                               className="count-tooltip-user-content-img"
//                                               width="15"
//                                               height="15"
//                                             />
//                                             <p className="count-tooltip-user-content">{data.user.displayName}</p>
//                                           </div>
//                                         );
//                                       })}
//                                       {projectCardValue?.recentProjectUser > 15 ? (
//                                         <p className="count-tooltip-user-content">
//                                           +{projectCardValue?.recentProjectUser - 15} others
//                                         </p>
//                                       ) : null}
//                                     </>
//                                   ) : (
//                                     <div className="count-tooltip-header"> No members</div>
//                                   )}
//                                 </div>
//                               </Tooltip>
//                             }
//                           >
//                             <div className="my-project-curently-work">
//                               {assignedTo}
//                               {projectCardValue.recentProjectDateText}
//                             </div>
//                           </OverlayTrigger>
//                           :
//                           <div className="my-project-curently-work my-project-current-work-color">

//                               {projectCardValue?.deadlineCrossedText}

//                             </div>

//                           }
//                         </Link>
//                       </div>
//                     );
//                   })
//                 )}
//               </div>
//               <div className="screenshot-load-more-button">
//                 {((filterId == "all" && !isAllLoaded) ||
//                   (filterId == "start" && !isCurrentlyWorkingLoaded) ||
//                   (filterId == "over" && !isOverWorkLoaded) ||
//                   (filterId == "archived" && !isArchivedLoaded) ||
//                   (filterId == "deadline" && !isDeadlineLoaded) ||
//                   (filterId == "todayWork" && !isTodayWorkLoaded)) &&
//                 !projectSearch ? (
//                   <>
//                     {isLoadingMore && !isLoadMoreButton ? (
//                       <div className="screenshot-load-more-button">
//                         <Loader />
//                       </div>
//                     ) : (
//                       <Button
//                         onClick={() => {
//                           handleLoadMore();
//                         }}
//                       >
//                         Load more
//                       </Button>
//                     )}
//                   </>
//                 ) : !projectSearch && projectWithSearch(myProjectsData?.myProjects?.projectsData)?.length ? (
//                   <p className="screenshot-load-more-button project-management-miled-color">
//                     You have seen all the projects
//                   </p>
//                 ) : null}
//               </div>
//             </>
//           ) : // : myProjectsData?.myProjects?.projectsData?.length >= 0 ? (
//           //   <p className="screenshot-load-more-button project-management-miled-color">No projects found.</p>
//           // )
//           null}
//           {projectStatusCountData[0]?.count == 0 && role != "Member" ? (
//             <div className="my-project-center-no-data">
//               <p>Yet to create a first project.</p>
//               <div className="my-project-center-no-data-div">
//                 {addButtonBasedOnRole === true ? (
//                   <Button
//                     variant="primary"
//                     className="font-weight-bold"
//                     onClick={() => handleShow("AddProject", teamDetails)}
//                   >
//                     Create Project
//                   </Button>
//                 ) : null}
//               </div>
//             </div>
//           ) : projectStatusCountData[0]?.count == 0 && role == "Member" ? (
//             <div className="my-project-center-no-data-member">
//               <div className="my-project-center-no-data-member-text-1"> You’re not assigned to any projects yet.</div>
//               <div className="my-project-center-no-data-member-text-2">
//                 {" "}
//                 Please connect with your manager or admin for project assignments.
//               </div>
//             </div>
//           ) : null}
//         </>
//       )}
//       <ProjectModal
//         projectModalShow={projectModalShow}
//         handleClose={handleClose}
//         timeZone={organisationSettings?.organisationTimezone}
//         role={role}
//         setAddedProjectId={setAddedProjectId}
//         history={history}
//         showUserMap={showUserMap}
//         setShowUserMap={setShowUserMap}
//         startTime={startTime}
//         endTime={endTime}
//       />
//       <DeleteProjectModal
//         showDeleteModal={showDeleteModal}
//         handleDeleteClose={handleDeleteClose}
//         startTime={startTime}
//         endTime={endTime}
//         role={role}
//       />
//     </div>
//   );
// };

export var ProjectEnableSection = function ProjectEnableSection(props) {
  var user = props.user,
    organisationId = props.organisationId,
    organisationSettings = props.organisationSettings,
    filterId = props.filterId,
    role = props.role,
    pageName = props.pageName,
    isTaskViewCheck = props.isTaskViewCheck,
    teamId = props.teamId,
    projectIds = props.projectIds,
    taskIds = props.taskIds,
    planName = props.planName,
    last14Days = props.last14Days,
    from = props.from,
    propsUserId = props.propsUserId,
    userIds = props.userIds,
    userActive = props.userActive,
    projectActive = props.projectActive,
    taskActive = props.taskActive,
    startDate = props.startDate,
    endDate = props.endDate,
    projectId = props.projectId,
    userUrl = props.userUrl;
  var _useMutation7 = useMutation(ADD_PROJECT_WORKDAY_SETTINGS_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    addProjectWorkDaySettings = _useMutation8[0],
    projectLoading = _useMutation8[1].loading;
  var handleEnableProjectManagement = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!projectLoading) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return");
        case 2:
          _context4.next = 4;
          return addProjectWorkDaySettings({
            variables: {
              organisationId: organisationId
            },
            awaitRefetchQueries: true,
            refetchQueries: [pageName == "my-projects" ? {
              query: MY_PROJECTS_QUERY,
              variables: {
                organisationId: organisationId,
                url: user === null || user === void 0 ? void 0 : user.uniqueUrl,
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                limit: LIMIT,
                offset: 0,
                filter: filterId,
                role: role
              }
            } : pageName == "task-overview" ? {
              query: TASK_OVERVIEW_SUMMARY_DATA_QUERY,
              variables: {
                organisationId: organisationId,
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                userId: user.userId,
                role: role,
                viewType: role != "Member" && isTaskViewCheck ? "teamView" : "myView"
              }
            } : pageName == "my-task" ? {
              query: GET_TASK_TRACKER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: [user.userId],
                projectId: projectIds.length ? projectIds : null,
                taskId: taskIds.length ? taskIds : null,
                limit: LIMIT,
                offset: 0,
                freePlanStartDate: planName == "free" ? last14Days ? last14Days[0] : null : null,
                freePlanEndDate: planName == "free" ? last14Days ? last14Days[1] : null : null,
                role: role
              }
            } : pageName == "work-history" ? {
              query: GET_TASK_TRACKER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: from ? [propsUserId] : userIds.length ? userIds : null,
                projectId: projectIds.length ? projectIds : null,
                taskId: taskIds.length ? taskIds : null,
                limit: LIMIT,
                offset: 0,
                freePlanStartDate: planName == "free" ? last14Days ? last14Days[0] : null : null,
                freePlanEndDate: planName == "free" ? last14Days ? last14Days[1] : null : null,
                role: role
              }
            } : pageName == "project-report" ? {
              query: GET_TASK_TRACKER_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userActive.length ? userActive : null,
                projectId: projectActive.length ? projectActive : null,
                taskId: taskActive.length ? taskActive : null,
                limit: LIMIT,
                offset: 0,
                startDate: startDate,
                endDate: endDate,
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              }
            } : pageName == "project-details" ? {
              query: PROJECT_DETAILS_SUMMARY_QUERY,
              variables: {
                projectId: projectId,
                organisationId: organisationId,
                teamId: teamId,
                startDate: moment(startDate).format("YYYY-MM-DD"),
                endDate: moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("YYYY-MM-DD"),
                timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                role: role,
                userUrl: userUrl
              }
            } : null, {
              query: WEB_ORGANISATION_SETTINGS_QUERY,
              variables: {
                organisationId: organisationId
              }
            }, {
              query: WORK_DAY_SETTINGS_QUERY,
              variables: {
                organisationId: organisationId
              }
            }]
          });
        case 4:
          response = _context4.sent;
          if (!(!response || !response.data || response.data.addProjectWorkDaySettings === false)) {
            _context4.next = 9;
            break;
          }
          throw new Error("error");
        case 9:
          toast.success("Settings enabled successfully!");
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })), [addProjectWorkDaySettings, projectLoading]);
  return /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenshot-card-warning-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "timelapse-warning-text-p"
  }, " ", "Hello ", user.displayName, ", you are yet to enable the project management feature.", " "), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "screenshot-enble-page",
    disabled: projectLoading,
    onClick: function onClick() {
      return handleEnableProjectManagement();
    }
  }, projectLoading ? "Loading..." : "Click to enable project management")));
};
var WorkSummary = function WorkSummary(props) {
  var myProjectSummary = props.myProjectSummary,
    history = props.history,
    dateFilter = props.dateFilter;
  return /*#__PURE__*/React.createElement("div", {
    className: "my-project-summary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card-title text-dark"
  }, "Projects Enabled To"), /*#__PURE__*/React.createElement("div", {
    className: "myproject-icon-div"
  }, Number(myProjectSummary.projectsEnabledTo) > 0 ? /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark myproject-icon-h4"
  }, myProjectSummary.projectsEnabledTo, " members") : /*#__PURE__*/React.createElement("div", {
    className: "myproject-add-projects-enabled-to",
    onClick: function onClick() {
      history.push("/settings/project-settings");
    }
  }, "Add Members"))), dateFilter === "Today" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "currently-working",
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-whole"
    }, myProjectSummary.workingProjectMembersUser.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, myProjectSummary.workingProjectMembersUser.slice(0, 15).map(function (data, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "count-tooltip-header"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: data.profileUrl ? data.profileUrl : Profile,
        className: "count-tooltip-user-content-img",
        width: "15",
        height: "15"
      }), /*#__PURE__*/React.createElement("p", {
        className: "count-tooltip-user-content"
      }, data.displayName));
    }), myProjectSummary.workingProjectMembersUserCount > 15 ? /*#__PURE__*/React.createElement("p", {
      className: "count-tooltip-user-content"
    }, "+", myProjectSummary.workingProjectMembersUserCount - 15, " others") : null) : /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-header"
    }, " No members")))
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card-title text-dark"
  }, "Currently Working in Projects"), /*#__PURE__*/React.createElement("div", {
    className: "myproject-icon-div"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark myproject-icon-h4"
  }, Number(myProjectSummary.projectsEnabledTo) > 0 ? myProjectSummary.workingProjectMembersUserCount : "-")))) : null, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card-title text-dark"
  }, "Today Time Spent"), /*#__PURE__*/React.createElement("div", {
    className: "myproject-icon-div"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark myproject-icon-h4"
  }, Number(myProjectSummary.projectsEnabledTo) > 0 ? myProjectSummary.todayProjectTime : "-"))), /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-project-dashboard-card-title text-dark"
  }, "Today Worked Tasks"), /*#__PURE__*/React.createElement("div", {
    className: "myproject-icon-div"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark myproject-icon-h4"
  }, Number(myProjectSummary.projectsEnabledTo) > 0 ? "".concat(myProjectSummary.taskCount, " ").concat(Number(myProjectSummary.taskCount) > 1 ? "tasks" : "task") : "-"))));
};
var AddMemberCard = function AddMemberCard(props) {
  var history = props.history,
    displayName = props.displayName;
  return /*#__PURE__*/React.createElement("div", {
    className: "my-project-add-member-card-root"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "my-project-add-member-card-redirection-link",
    onClick: function onClick() {
      history.push("/settings/project-settings");
    }
  }, "Hello ".concat(displayName, ", Click here to enable the projects dashboard to the your members, so they can see the projects & tasks on their desktop app."))));
};

// const DeleteProjectModal = (props) => {
//   const { showDeleteModal, handleDeleteClose, startTime, endTime, role } = props;

//   if (showDeleteModal === null) {
//     return null;
//   }

//   const { organisationId, projectName, projectId, teamId, startDate, endDate } = showDeleteModal;

//   const [deleteStatus, setDeleteStatus] = React.useState(null);

//   const [editProjectAndDeleteProject, { loading: editProjectAndDeleteProjectLoading }] = useMutation(
//     EDIT_PROJECT_AND_DELETE_PROJECT_MUTATION
//   );

//   const handleDeleteProject = React.useCallback(
//     (status, projectId) => async () => {
//       if (editProjectAndDeleteProjectLoading) return;

//       const response = await editProjectAndDeleteProject({
//         variables: {
//           projectName: null,
//           budget: null,
//           projectId,
//           teamId: null,
//           status,
//           organisationId,
//         },
//         awaitRefetchQueries: true,
//         refetchQueries: [
//           {
//             query: MY_PROJECTS_QUERY,
//             variables: {
//               organisationId,
//               url: user?.uniqueUrl,
//               // startDate: Number(moment(startDate).format("x")),
//               // endDate: Number(moment(endDate ?? startDate).format("x")),
//               filter: "all",
//               role,
//             },
//           },
//           {
//             query: MY_PROJECT_SUMMARY_QUERY,
//             variables: {
//               organisationId,
//               timeZone,
//               startDate: startTime,
//               endDate: endTime,
//             },
//           },
//         ],
//       });

//       if (!response || !response.data || !response.data.editProjectAndDeleteProject) {
//         setDeleteStatus("error");
//       } else {
//         setDeleteStatus(true);
//         handleDeleteClose();
//         toast.success("Project deleted successfully!");
//       }
//     },
//     [editProjectAndDeleteProject, editProjectAndDeleteProjectLoading]
//   );

//   return (
//     <Modal show={showDeleteModal} onHide={handleDeleteClose}>
//       <Modal.Header className="project-details-task-card-delete-header" closeButton>
//         <Modal.Title className="project-details-task-card-delete-title">Delete Project</Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="project-details-task-card-delete-body">
//         Are you sure you want to delete project{" "}
//         <span className="project-details-task-card-delete-task-name">{projectName}?</span> By doing this you will lose
//         all of your project data including tasks, their comments and history.
//       </Modal.Body>
//       <Modal.Footer>
//         <Button
//           variant="outline-secondary"
//           className="project-details-task-card-delete-cancel-button"
//           onClick={handleDeleteClose}
//         >
//           Cancel
//         </Button>
//         <Button
//           variant="danger"
//           className="project-details-task-card-delete-button"
//           onClick={handleDeleteProject("inactive", projectId)}
//         >
//           {deleteStatus === true ? "Deleted" : editProjectAndDeleteProjectLoading ? `Loading` : `Delete Project`}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default MyProjects;

// productive % first ui for ref
{
  /* <div className="d-flex align-items-center project-card-edit-button-spacer">
  <div className="project-card-chart">
  <Doughnut
    data={{
      datasets: [
        {
          data: [projectCardValuePercent, projectCardValuePercent - 100],
          backgroundColor: ["#51BE71", "#eee"],
          hoverBackgroundColor: ["#51BE71", "#eee"],
          borderWidth: 0,
        },
      ],
      text: "23%",
    }}
    width={50}
    height={30}
    options={{
      maintainAspectRatio: false,
      responsive: false,
      cutoutPercentage: 80,
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
    }}
  />
  <div className="project-card-chart-percent">{projectCardValuePercent}</div>
  </div>
  <div className="project-card-chart-data">
  <div>%Productivity</div>
  </div>
  </div> */
}